var bs = Object.defineProperty, ws = Object.defineProperties;
var Rs = Object.getOwnPropertyDescriptors;
var Te = Object.getOwnPropertySymbols;
var qn = Object.prototype.hasOwnProperty, Yn = Object.prototype.propertyIsEnumerable;
var ar = (e, t, r) => t in e ? bs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, S = (e, t) => {
  for (var r in t || (t = {}))
    qn.call(t, r) && ar(e, r, t[r]);
  if (Te)
    for (var r of Te(t))
      Yn.call(t, r) && ar(e, r, t[r]);
  return e;
}, P = (e, t) => ws(e, Rs(t));
var sr = (e, t) => {
  var r = {};
  for (var n in e)
    qn.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && Te)
    for (var n of Te(e))
      t.indexOf(n) < 0 && Yn.call(e, n) && (r[n] = e[n]);
  return r;
};
var R = (e, t, r) => ar(e, typeof t != "symbol" ? t + "" : t, r);
var k = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
});
import { T as Lo, U as Ls, W as Zr, X as Ps, s as Dt, Y as at, Z as Po, _ as No, $ as Io, a0 as Ns, w as Is, a1 as Cs, a2 as Ms, a3 as xs, a4 as Ds, a5 as Us, a6 as Co, a7 as ke, q as Bs, a8 as ur, a9 as cr, aa as ks, c as Gs, n as Hs, o as $s, L as js, h as Vs, t as Fs, ab as Xs, D as zs, ac as Ws, I as Kn, E as fr, ad as qs, ae as Ys, J as Ks, K as Js, N as Zs, O as Qs, Q as tu, R as eu, af as ru, ag as nu, ah as Jn, ai as iu, aj as ou, ak as au } from "./common-B7EHpKc9.js";
import { a as su, i as Mo } from "./buffer-DIFxvF2Q.js";
import { LDObserve as uu } from "./LDObserve.js";
const xo = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var pt = /* @__PURE__ */ ((e) => (e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea", e))(pt || {}), F = /* @__PURE__ */ ((e) => (e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend", e))(F || {}), Do = { exports: {} }, lr = { exports: {} }, Zn;
function cu() {
  return Zn || (Zn = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Lo, function() {
      function r(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], f = o.concat(a, u, c, s);
      function l(p) {
        if (p)
          for (var E = 0; E < f.length; E++)
            p[f[E]] !== void 0 && this["set" + n(f[E])](p[f[E]]);
      }
      l.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof l)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new l(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", E = this.getLineNumber() || "", g = this.getColumnNumber() || "", y = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + E + ":" + g + ")" : "[eval]:" + E + ":" + g : y ? y + " (" + p + ":" + E + ":" + g + ")" : p + ":" + E + ":" + g;
        }
      }, l.fromString = function(E) {
        var g = E.indexOf("("), y = E.lastIndexOf(")"), b = E.substring(0, g), L = E.substring(g + 1, y).split(","), G = E.substring(y + 1);
        if (G.indexOf("@") === 0)
          var B = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(G, ""), Lt = B[1], Vt = B[2], Pt = B[3];
        return new l({
          functionName: b,
          args: L || void 0,
          fileName: Lt,
          lineNumber: Vt || void 0,
          columnNumber: Pt || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        l.prototype["get" + n(o[d])] = i(o[d]), l.prototype["set" + n(o[d])] = /* @__PURE__ */ function(p) {
          return function(E) {
            this[p] = !!E;
          };
        }(o[d]);
      for (var h = 0; h < a.length; h++)
        l.prototype["get" + n(a[h])] = i(a[h]), l.prototype["set" + n(a[h])] = /* @__PURE__ */ function(p) {
          return function(E) {
            if (!r(E))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(E);
          };
        }(a[h]);
      for (var _ = 0; _ < u.length; _++)
        l.prototype["get" + n(u[_])] = i(u[_]), l.prototype["set" + n(u[_])] = /* @__PURE__ */ function(p) {
          return function(E) {
            this[p] = String(E);
          };
        }(u[_]);
      return l;
    });
  }(lr)), lr.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(cu());
  })(Lo, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, f = s.exec(c.replace(/[()]/g, ""));
        return [f[1], f[2] || void 0, f[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(f) {
          return !!f.match(o);
        }, this);
        return s.map(function(f) {
          f.indexOf("(eval ") > -1 && (f = f.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var l = f.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = l.match(/ (\((.+):(\d+):(\d+)\)$)/);
          l = d ? l.replace(d[0], "") : l;
          var h = l.split(/\s+/).slice(1), _ = this.extractLocation(d ? d[1] : h.pop()), p = h.join(" ") || void 0, E = ["eval", "<anonymous>"].indexOf(_[0]) > -1 ? void 0 : _[0];
          return new n({
            functionName: p,
            fileName: E,
            lineNumber: _[1],
            columnNumber: _[2],
            source: f
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(f) {
          return !f.match(a);
        }, this);
        return s.map(function(f) {
          if (f.indexOf(" > eval") > -1 && (f = f.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), f.indexOf("@") === -1 && f.indexOf(":") === -1)
            return new n({
              functionName: f
            });
          var l = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = f.match(l), h = d && d[1] ? d[1] : void 0, _ = this.extractLocation(f.replace(l, ""));
          return new n({
            functionName: h,
            fileName: _[0],
            lineNumber: _[1],
            columnNumber: _[2],
            source: f
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, f = c.message.split(`
`), l = [], d = 2, h = f.length; d < h; d += 2) {
          var _ = s.exec(f[d]);
          _ && l.push(new n({
            fileName: _[2],
            lineNumber: _[1],
            source: f[d]
          }));
        }
        return l;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, f = c.stacktrace.split(`
`), l = [], d = 0, h = f.length; d < h; d += 2) {
          var _ = s.exec(f[d]);
          _ && l.push(
            new n({
              functionName: _[3] || void 0,
              fileName: _[2],
              lineNumber: _[1],
              source: f[d]
            })
          );
        }
        return l;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(f) {
          return !!f.match(i) && !f.match(/^Error created at/);
        }, this);
        return s.map(function(f) {
          var l = f.split("@"), d = this.extractLocation(l.pop()), h = l.shift() || "", _ = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          h.match(/\(([^)]*)\)/) && (p = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var E = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: _,
            args: E,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: f
          });
        }, this);
      }
    };
  });
})(Do);
var fu = Do.exports;
const Qn = /* @__PURE__ */ Ls(fu);
function Ze(e) {
  try {
    return Qn.parse(e);
  } catch (t) {
    try {
      return Qn.parse(new Error());
    } catch (r) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: r
      }), [];
    }
  }
}
const Ny = {
  level: [...xo],
  logger: "console",
  stringifyOptions: {
    depthOfLimit: 10,
    numOfKeysLimit: 100,
    stringLengthLimit: 1e3
  }
};
function lu(e, t) {
  const r = t.logger;
  if (!r)
    return () => {
    };
  let n;
  typeof r == "string" ? n = window[r] : n = r;
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let f = [];
      s && (f = Ze(s));
      const l = [
        Zr(c, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: f,
        time: Date.now(),
        value: l
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? Ps(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        e(du(u, t, ...s));
      } catch (f) {
        c("highlight logger error:", f, ...s);
      }
    }) : () => {
    };
  }
}
function du(e, t, ...r) {
  const n = Ze(new Error()), i = t.serializeConsoleAttributes ? r.map(
    (o) => typeof o == "object" ? Zr(o, t.stringifyOptions) : o
  ) : r.filter((o) => typeof o != "object").map((o) => `${o}`);
  return {
    type: e,
    trace: n,
    value: i,
    attributes: Zr(
      r.filter((o) => typeof o == "object").reduce((o, a) => S(S({}, o), a), {}),
      t.stringifyOptions
    ),
    time: Date.now()
  };
}
const pu = {
  start: 0,
  end: 3
}, hu = {
  start: 4,
  end: 5
}, dr = {
  start: 6,
  end: 7
}, pr = {
  start: 8,
  end: 8
}, _u = {
  start: 9,
  end: 9
}, vu = {
  start: 10,
  end: 15
};
function Eu() {
  if (crypto && crypto.getRandomValues) {
    const t = new Uint8Array(16);
    return crypto.getRandomValues(t), [...t.values()];
  }
  const e = [];
  for (let t = 0; t < 16; t += 1)
    e.push(Math.floor(Math.random() * 256));
  return e;
}
function Nt(e, t) {
  let r = "";
  for (let n = t.start; n <= t.end; n += 1)
    r += e[n].toString(16).padStart(2, "0");
  return r;
}
function gu(e) {
  return e[pr.start] = (e[pr.start] | 128) & 191, e[dr.start] = e[dr.start] & 15 | 64, `${Nt(e, pu)}-${Nt(e, hu)}-${Nt(e, dr)}-${Nt(e, pr)}${Nt(e, _u)}-${Nt(e, vu)}`;
}
function yu() {
  const e = Eu();
  return gu(e);
}
function Uo() {
  return typeof crypto != "undefined" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : yu();
}
function hr(e, t, r, n) {
  var c, s, f, l;
  let i = n != null ? n : t, o = Ze(i), a = {};
  t instanceof Error && (t = t.message, t.cause && (a = { "exception.cause": t.cause }));
  const u = Tu(o);
  e({
    error: i,
    event: Dt(t),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (c = u[0]) != null && c.lineNumber ? (s = u[0]) == null ? void 0 : s.lineNumber : 0,
    columnNumber: (f = u[0]) != null && f.columnNumber ? (l = u[0]) == null ? void 0 : l.columnNumber : 0,
    stackTrace: u,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: a ? Dt(a) : void 0,
    id: Uo()
  });
}
const mu = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined") return () => {
  };
  const r = window.onerror = (a, u, c, s, f) => {
    hr(e, a, u, f);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? hr(
        e,
        a.reason,
        a.type,
        u.getStack()
      ) : hr(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      R(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return t && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, Tu = (e) => {
  var r, n;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (r = t.fileName) != null && r.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Su = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Ou = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var Au = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, gt = "1.9.0", ti = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function bu(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(ti);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function o(u) {
    return r.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (r.has(c))
      return !1;
    var s = c.match(ti);
    if (!s)
      return o(c);
    var f = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return f.prerelease != null || i.major !== f.major ? o(c) : i.major === 0 ? i.minor === f.minor && i.patch <= f.patch ? a(c) : o(c) : i.minor <= f.minor ? a(c) : o(c);
  };
}
var wu = bu(gt), Ru = gt.split(".")[0], oe = Symbol.for("opentelemetry.js.api." + Ru), ae = Au;
function pe(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = ae[oe] = (i = ae[oe]) !== null && i !== void 0 ? i : {
    version: gt
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== gt) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + gt);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + gt + "."), !0;
}
function mt(e) {
  var t, r, n = (t = ae[oe]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !wu(n)))
    return (r = ae[oe]) === null || r === void 0 ? void 0 : r[e];
}
function he(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + gt + ".");
  var r = ae[oe];
  r && delete r[e];
}
var Lu = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Pu = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Nu = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Wt("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Wt("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Wt("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Wt("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Wt("verbose", this._namespace, t);
    }, e;
  }()
);
function Wt(e, t, r) {
  var n = mt("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, Pu([], Lu(r), !1));
}
var w;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(w || (w = {}));
function Iu(e, t) {
  e < w.NONE ? e = w.NONE : e > w.ALL && (e = w.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", w.ERROR),
    warn: r("warn", w.WARN),
    info: r("info", w.INFO),
    debug: r("debug", w.DEBUG),
    verbose: r("verbose", w.VERBOSE)
  };
}
var Cu = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Mu = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, xu = "diag", K = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = mt("diag");
          if (u)
            return u[i].apply(u, Mu([], Cu(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: w.INFO }), i === r) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var f = mt("diag"), l = Iu((u = o.logLevel) !== null && u !== void 0 ? u : w.INFO, i);
        if (f && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          f.warn("Current logger will be overwritten from " + d), l.warn("Current logger will overwrite one already registered from " + d);
        }
        return pe("diag", l, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        he(xu, r);
      }, r.createComponentLogger = function(i) {
        return new Nu(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), Du = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Uu = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Bu = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = Du(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = Uu(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), ku = Symbol("BaggageEntryMetadata"), Gu = K.instance();
function Hu(e) {
  return e === void 0 && (e = {}), new Bu(new Map(Object.entries(e)));
}
function Bo(e) {
  return typeof e != "string" && (Gu.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: ku,
    toString: function() {
      return e;
    }
  };
}
function _e(e) {
  return Symbol.for(e);
}
var $u = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), ht = new $u(), Ot = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ju = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return Ju;
    }, e.prototype.createHistogram = function(t, r) {
      return Zu;
    }, e.prototype.createCounter = function(t, r) {
      return Ku;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return Qu;
    }, e.prototype.createObservableGauge = function(t, r) {
      return ec;
    }, e.prototype.createObservableCounter = function(t, r) {
      return tc;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return rc;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), Qe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), Vu = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(Qe)
), Fu = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(Qe)
), Xu = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(Qe)
), zu = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(Qe)
), Pn = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), Wu = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Pn)
), qu = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Pn)
), Yu = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Pn)
), ko = new ju(), Ku = new Vu(), Ju = new Xu(), Zu = new zu(), Qu = new Fu(), tc = new Wu(), ec = new qu(), rc = new Yu();
function nc() {
  return ko;
}
var lt;
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(lt || (lt = {}));
var ic = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, oc = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, ac = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, sc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, uc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return ht;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, sc([n], ac(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), cc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, fc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, _r = "context", lc = new uc(), tr = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return pe(_r, t, K.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, fc([t, r, n], cc(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return mt(_r) || lc;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), he(_r, K.instance());
    }, e;
  }()
), J;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(J || (J = {}));
var Go = "0000000000000000", Ho = "00000000000000000000000000000000", $o = {
  traceId: Ho,
  spanId: Go,
  traceFlags: J.NONE
}, te = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = $o), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), Nn = _e("OpenTelemetry Context Key SPAN");
function In(e) {
  return e.getValue(Nn) || void 0;
}
function dc() {
  return In(tr.getInstance().active());
}
function Cn(e, t) {
  return e.setValue(Nn, t);
}
function pc(e) {
  return e.deleteValue(Nn);
}
function hc(e, t) {
  return Cn(e, new te(t));
}
function jo(e) {
  var t;
  return (t = In(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var _c = /^([0-9a-f]{32})$/i, vc = /^[0-9a-f]{16}$/i;
function Vo(e) {
  return _c.test(e) && e !== Ho;
}
function Ec(e) {
  return vc.test(e) && e !== Go;
}
function ve(e) {
  return Vo(e.traceId) && Ec(e.spanId);
}
function gc(e) {
  return new te(e);
}
var vr = tr.getInstance(), Fo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = vr.active());
      var i = !!(r != null && r.root);
      if (i)
        return new te();
      var o = n && jo(n);
      return yc(o) && ve(o) ? new te(o) : new te();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : vr.active(), s = this.startSpan(t, o, c), f = Cn(c, s);
        return vr.with(f, u, void 0, s);
      }
    }, e;
  }()
);
function yc(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var mc = new Fo(), Tc = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : mc;
    }, e;
  }()
), Sc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new Fo();
    }, e;
  }()
), Oc = new Sc(), ei = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new Tc(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Oc;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), Ge;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Ge || (Ge = {}));
var se;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(se || (se = {}));
var He;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(He || (He = {}));
var O = tr.getInstance(), v = K.instance(), Ac = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return ko;
    }, e;
  }()
), bc = new Ac(), Er = "metrics", wc = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return pe(Er, t, K.instance());
    }, e.prototype.getMeterProvider = function() {
      return mt(Er) || bc;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      he(Er, K.instance());
    }, e;
  }()
), $t = wc.getInstance(), Rc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), Mn = _e("OpenTelemetry Baggage Key");
function Xo(e) {
  return e.getValue(Mn) || void 0;
}
function Lc() {
  return Xo(tr.getInstance().active());
}
function Pc(e, t) {
  return e.setValue(Mn, t);
}
function Nc(e) {
  return e.deleteValue(Mn);
}
var gr = "propagation", Ic = new Rc(), Cc = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = Hu, this.getBaggage = Xo, this.getActiveBaggage = Lc, this.setBaggage = Pc, this.deleteBaggage = Nc;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return pe(gr, t, K.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = oc), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = ic), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      he(gr, K.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return mt(gr) || Ic;
    }, e;
  }()
), D = Cc.getInstance(), yr = "trace", Mc = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new ei(), this.wrapSpanContext = gc, this.isSpanContextValid = ve, this.deleteSpan = pc, this.getSpan = In, this.getActiveSpan = dc, this.getSpanContext = jo, this.setSpan = Cn, this.setSpanContext = hc;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = pe(yr, this._proxyTracerProvider, K.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return mt(yr) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      he(yr, K.instance()), this._proxyTracerProvider = new ei();
    }, e;
  }()
), A = Mc.getInstance(), xc = _e("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function zo(e) {
  return e.getValue(xc) === !0;
}
var Dc = "=", Qr = ";", tn = ",", mr = "baggage", Uc = 180, Bc = 4096, kc = 8192, Gc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Hc(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? tn : "") + r;
    return n.length > kc ? t : n;
  }, "");
}
function $c(e) {
  return e.getAllEntries().map(function(t) {
    var r = Gc(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += Qr + i.metadata.toString()), o;
  });
}
function jc(e) {
  var t = e.split(Qr);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Dc);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Bo(t.join(Qr))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Vc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = D.getBaggage(t);
      if (!(!i || zo(t))) {
        var o = $c(i).filter(function(u) {
          return u.length <= Bc;
        }).slice(0, Uc), a = Hc(o);
        a.length > 0 && n.set(r, mr, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, mr), o = Array.isArray(i) ? i.join(tn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(tn);
      return u.forEach(function(c) {
        var s = jc(c);
        if (s) {
          var f = { value: s.value };
          s.metadata && (f.metadata = s.metadata), a[s.key] = f;
        }
      }), Object.entries(a).length === 0 ? t : D.setBaggage(t, D.createBaggage(a));
    }, e.prototype.fields = function() {
      return [mr];
    }, e;
  }()
), en;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(en || (en = {}));
var Fc = ",", Xc = ["OTEL_SDK_DISABLED"];
function zc(e) {
  return Xc.indexOf(e) > -1;
}
var Wc = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function qc(e) {
  return Wc.indexOf(e) > -1;
}
var Yc = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function Kc(e) {
  return Yc.indexOf(e) > -1;
}
var Tr = 1 / 0, Sr = 128, Jc = 128, Zc = 128, Wo = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: w.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Tr,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Sr,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Tr,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Sr,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Tr,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Sr,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Jc,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Zc,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: en.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function Qc(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function tf(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function ef(e, t, r, n) {
  n === void 0 && (n = Fc);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var rf = {
  ALL: w.ALL,
  VERBOSE: w.VERBOSE,
  DEBUG: w.DEBUG,
  INFO: w.INFO,
  WARN: w.WARN,
  ERROR: w.ERROR,
  NONE: w.NONE
};
function nf(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = rf[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function of(e) {
  var t = {};
  for (var r in Wo) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        nf(n, t, e);
        break;
      default:
        if (zc(n))
          Qc(n, t, e);
        else if (qc(n))
          tf(n, t, e);
        else if (Kc(n))
          ef(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var af = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function sf() {
  var e = of(af);
  return Object.assign({}, Wo, e);
}
var rn = performance, uf = 9, cf = 6, ff = Math.pow(10, cf), ri = Math.pow(10, uf);
function ni(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * ff);
  return [r, n];
}
function lf() {
  var e = rn.timeOrigin;
  if (typeof e != "number") {
    var t = rn;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function df(e) {
  var t = ni(lf()), r = ni(rn.now());
  return pf(t, r);
}
function pf(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= ri && (r[1] -= ri, r[0] += 1), r;
}
var x;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(x || (x = {}));
var hf = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, _f = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = hf(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), nn = "[_0-9a-z-*/]", vf = "[a-z]" + nn + "{0,255}", Ef = "[a-z0-9]" + nn + "{0,240}@[a-z]" + nn + "{0,13}", gf = new RegExp("^(?:" + vf + "|" + Ef + ")$"), yf = /^[ -~]{0,255}[!-~]$/, mf = /,|=/;
function Tf(e) {
  return gf.test(e);
}
function Sf(e) {
  return yf.test(e) && !mf.test(e);
}
var ii = 32, Of = 512, oi = ",", ai = "=", Af = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + ai + t.get(n)), r;
      }, []).join(oi);
    }, e.prototype._parse = function(t) {
      t.length > Of || (this._internalState = t.split(oi).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(ai);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          Tf(a) && Sf(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > ii && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, ii))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Or = "traceparent", Ar = "tracestate", bf = "00", wf = "(?!ff)[\\da-f]{2}", Rf = "(?![0]{32})[\\da-f]{32}", Lf = "(?![0]{16})[\\da-f]{16}", Pf = "[\\da-f]{2}", Nf = new RegExp("^\\s?(" + wf + ")-(" + Rf + ")-(" + Lf + ")-(" + Pf + ")(-.*)?\\s?$");
function If(e) {
  var t = Nf.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var Cf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = A.getSpanContext(t);
      if (!(!i || zo(t) || !ve(i))) {
        var o = bf + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || J.NONE).toString(16);
        n.set(r, Or, o), i.traceState && n.set(r, Ar, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Or);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = If(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Ar);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Af(typeof c == "string" ? c : void 0);
      }
      return A.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Or, Ar];
    }, e;
  }()
), Mf = "[object Object]", xf = "[object Null]", Df = "[object Undefined]", Uf = Function.prototype, qo = Uf.toString, Bf = qo.call(Object), kf = Gf(Object.getPrototypeOf, Object), Yo = Object.prototype, Ko = Yo.hasOwnProperty, _t = Symbol ? Symbol.toStringTag : void 0, Jo = Yo.toString;
function Gf(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function si(e) {
  if (!Hf(e) || $f(e) !== Mf)
    return !1;
  var t = kf(e);
  if (t === null)
    return !0;
  var r = Ko.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && qo.call(r) === Bf;
}
function Hf(e) {
  return e != null && typeof e == "object";
}
function $f(e) {
  return e == null ? e === void 0 ? Df : xf : _t && _t in Object(e) ? jf(e) : Vf(e);
}
function jf(e) {
  var t = Ko.call(e, _t), r = e[_t], n = !1;
  try {
    e[_t] = void 0, n = !0;
  } catch (o) {
  }
  var i = Jo.call(e);
  return n && (t ? e[_t] = r : delete e[_t]), i;
}
function Vf(e) {
  return Jo.call(e);
}
var Ff = 20;
function Xf() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = Zo(r, e.shift(), 0, n);
  return r;
}
function br(e) {
  return $e(e) ? e.slice() : e;
}
function Zo(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Ff)) {
    if (r++, Me(e) || Me(t) || Qo(t))
      i = br(t);
    else if ($e(e)) {
      if (i = e.slice(), $e(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(br(t[o]));
      else if (qt(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = br(t[c]);
        }
    } else if (qt(e))
      if (qt(t)) {
        if (!zf(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Me(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var f = i[c], l = s;
            if (ui(e, c, n) || ui(t, c, n))
              delete i[c];
            else {
              if (qt(f) && qt(l)) {
                var d = n.get(f) || [], h = n.get(l) || [];
                d.push({ obj: e, key: c }), h.push({ obj: t, key: c }), n.set(f, d), n.set(l, h);
              }
              i[c] = Zo(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function ui(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function $e(e) {
  return Array.isArray(e);
}
function Qo(e) {
  return typeof e == "function";
}
function qt(e) {
  return !Me(e) && !$e(e) && !Qo(e) && typeof e == "object";
}
function Me(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function zf(e, t) {
  return !(!si(e) || !si(t));
}
var ta = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), Wf = new ta(), qf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new ta();
    }, e;
  }()
), ea = new qf(), Yf = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Wf;
    }, e;
  }()
), ci = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new Yf(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : ea;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), Kf = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Se = Symbol.for("io.opentelemetry.js.api.logs"), Yt = Kf;
function Jf(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var fi = 1, Zf = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new ci();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return Yt[Se] ? this.getLoggerProvider() : (Yt[Se] = Jf(fi, t, ea), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = Yt[Se]) === null || t === void 0 ? void 0 : t.call(Yt, fi)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete Yt[Se], this._proxyLoggerProvider = new ci();
    }, e;
  }()
), Ee = Zf.getInstance();
function Qf(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function tl(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function el(e) {
  var t, r, n = e.tracerProvider || A.getTracerProvider(), i = e.meterProvider || $t.getMeterProvider(), o = e.loggerProvider || Ee.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return Qf(a, n, i, o), function() {
    tl(a);
  };
}
function on(e) {
  return typeof e == "function";
}
var U = console.error.bind(console);
function Kt(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function ge(e) {
  e && e.logger && (on(e.logger) ? U = e.logger : U("new logger isn't a function, not replacing"));
}
function ra(e, t, r) {
  if (!e || !e[t]) {
    U("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    U("no wrapper function"), U(new Error().stack);
    return;
  }
  if (!on(e[t]) || !on(r)) {
    U("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return Kt(i, "__original", n), Kt(i, "__unwrap", function() {
    e[t] === i && Kt(e, t, n);
  }), Kt(i, "__wrapped", !0), Kt(e, t, i), i;
}
function rl(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    U("must provide one or more modules to patch"), U(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    U("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      ra(n, i, r);
    });
  });
}
function na(e, t) {
  if (!e || !e[t]) {
    U("no function to unwrap."), U(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    U("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function nl(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    U("must provide one or more modules to patch"), U(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    U("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      na(r, n);
    });
  });
}
ge.wrap = ra;
ge.massWrap = rl;
ge.unwrap = na;
ge.massUnwrap = nl;
var C = ge, an = function() {
  return an = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, an.apply(this, arguments);
}, il = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = C.wrap, this._unwrap = C.unwrap, this._massWrap = C.massWrap, this._massUnwrap = C.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = A.getTracer(t, r), this._meter = $t.getMeter(t, r), this._logger = Ee.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = an({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), ol = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), al = (
  /** @class */
  function(e) {
    ol(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(il)
);
function M(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var je = performance, sl = "traceparent", ia = _e("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function ul(e) {
  return e.setValue(ia, !0);
}
function xn(e) {
  return e.getValue(ia) === !0;
}
var cl = "=", sn = ";", un = ",", wr = "baggage", fl = 180, ll = 4096, dl = 8192, pl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function hl(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? un : "") + r;
    return n.length > dl ? t : n;
  }, "");
}
function _l(e) {
  return e.getAllEntries().map(function(t) {
    var r = pl(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += sn + i.metadata.toString()), o;
  });
}
function vl(e) {
  var t = e.split(sn);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(cl);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Bo(t.join(sn))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var El = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = D.getBaggage(t);
      if (!(!i || xn(t))) {
        var o = _l(i).filter(function(u) {
          return u.length <= ll;
        }).slice(0, fl), a = hl(o);
        a.length > 0 && n.set(r, wr, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, wr), o = Array.isArray(i) ? i.join(un) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(un);
      return u.forEach(function(c) {
        var s = vl(c);
        if (s) {
          var f = { value: s.value };
          s.metadata && (f.metadata = s.metadata), a[s.key] = f;
        }
      }), Object.entries(a).length === 0 ? t : D.setBaggage(t, D.createBaggage(a));
    }, e.prototype.fields = function() {
      return [wr];
    }, e;
  }()
), oa = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, gl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function xe(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = oa(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = gl(o.value, 2), u = a[0], c = a[1];
      if (!yl(u)) {
        v.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!aa(c)) {
        v.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function yl(e) {
  return typeof e == "string" && e.length > 0;
}
function aa(e) {
  return e == null ? !0 : Array.isArray(e) ? ml(e) : sa(e);
}
function ml(e) {
  var t, r, n;
  try {
    for (var i = oa(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (sa(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function sa(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Tl() {
  return function(e) {
    v.error(Sl(e));
  };
}
function Sl(e) {
  return typeof e == "string" ? e : JSON.stringify(Ol(e));
}
function Ol(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Al = Tl();
function kt(e) {
  try {
    Al(e);
  } catch (t) {
  }
}
var W;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(W || (W = {}));
var bl = ",", wl = ["OTEL_SDK_DISABLED"];
function Rl(e) {
  return wl.indexOf(e) > -1;
}
var Ll = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Pl(e) {
  return Ll.indexOf(e) > -1;
}
var Nl = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function Il(e) {
  return Nl.indexOf(e) > -1;
}
var De = 1 / 0, Ue = 128, Cl = 128, Ml = 128, ua = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: w.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: De,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Ue,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: De,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Ue,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: De,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Ue,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Cl,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Ml,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: W.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function xl(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function Dl(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function Ul(e, t, r, n) {
  n === void 0 && (n = bl);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var Bl = {
  ALL: w.ALL,
  VERBOSE: w.VERBOSE,
  DEBUG: w.DEBUG,
  INFO: w.INFO,
  WARN: w.WARN,
  ERROR: w.ERROR,
  NONE: w.NONE
};
function kl(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = Bl[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function ca(e) {
  var t = {};
  for (var r in ua) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        kl(n, t, e);
        break;
      default:
        if (Rl(n))
          xl(n, t, e);
        else if (Pl(n))
          Dl(n, t, e);
        else if (Il(n))
          Ul(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var fa = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function ue() {
  var e = ca(fa);
  return Object.assign({}, ua, e);
}
function Gl() {
  return ca(fa);
}
var Ut = performance, Hl = "exception.type", $l = "exception.message", jl = "exception.stacktrace", Vl = "http.response_content_length", Fl = "http.response_content_length_uncompressed", Rr = Hl, Lr = $l, Xl = jl, zl = Vl, Wl = Fl, ql = 9, Yl = 6, Kl = Math.pow(10, Yl), Ve = Math.pow(10, ql);
function ct(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Kl);
  return [r, n];
}
function Dn() {
  var e = Ut.timeOrigin;
  if (typeof e != "number") {
    var t = Ut;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function la(e) {
  var t = ct(Dn()), r = ct(typeof e == "number" ? e : Ut.now());
  return da(t, r);
}
function ee(e) {
  if (Un(e))
    return e;
  if (typeof e == "number")
    return e < Dn() ? la(e) : ct(e);
  if (e instanceof Date)
    return ct(e.getTime());
  throw TypeError("Invalid input type");
}
function Jl(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += Ve), [r, n];
}
function ft(e) {
  return e[0] * Ve + e[1];
}
function Un(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function li(e) {
  return Un(e) || typeof e == "number" || e instanceof Date;
}
function da(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= Ve && (r[1] -= Ve, r[0] += 1), r;
}
var cn;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(cn || (cn = {}));
var Zl = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ql = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = Zl(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), fn = "[_0-9a-z-*/]", td = "[a-z]" + fn + "{0,255}", ed = "[a-z0-9]" + fn + "{0,240}@[a-z]" + fn + "{0,13}", rd = new RegExp("^(?:" + td + "|" + ed + ")$"), nd = /^[ -~]{0,255}[!-~]$/, id = /,|=/;
function od(e) {
  return rd.test(e);
}
function ad(e) {
  return nd.test(e) && !id.test(e);
}
var di = 32, sd = 512, pi = ",", hi = "=", ud = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + hi + t.get(n)), r;
      }, []).join(pi);
    }, e.prototype._parse = function(t) {
      t.length > sd || (this._internalState = t.split(pi).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(hi);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          od(a) && ad(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > di && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, di))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Pr = "traceparent", Nr = "tracestate", cd = "00", fd = "(?!ff)[\\da-f]{2}", ld = "(?![0]{32})[\\da-f]{32}", dd = "(?![0]{16})[\\da-f]{16}", pd = "[\\da-f]{2}", hd = new RegExp("^\\s?(" + fd + ")-(" + ld + ")-(" + dd + ")-(" + pd + ")(-.*)?\\s?$");
function _d(e) {
  var t = hd.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var vd = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = A.getSpanContext(t);
      if (!(!i || xn(t) || !ve(i))) {
        var o = cd + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || J.NONE).toString(16);
        n.set(r, Pr, o), i.traceState && n.set(r, Nr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Pr);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = _d(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Nr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new ud(typeof c == "string" ? c : void 0);
      }
      return A.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Pr, Nr];
    }, e;
  }()
), Ed = "[object Object]", gd = "[object Null]", yd = "[object Undefined]", md = Function.prototype, pa = md.toString, Td = pa.call(Object), Sd = Od(Object.getPrototypeOf, Object), ha = Object.prototype, _a = ha.hasOwnProperty, vt = Symbol ? Symbol.toStringTag : void 0, va = ha.toString;
function Od(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function _i(e) {
  if (!Ad(e) || bd(e) !== Ed)
    return !1;
  var t = Sd(e);
  if (t === null)
    return !0;
  var r = _a.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && pa.call(r) === Td;
}
function Ad(e) {
  return e != null && typeof e == "object";
}
function bd(e) {
  return e == null ? e === void 0 ? yd : gd : vt && vt in Object(e) ? wd(e) : Rd(e);
}
function wd(e) {
  var t = _a.call(e, vt), r = e[vt], n = !1;
  try {
    e[vt] = void 0, n = !0;
  } catch (o) {
  }
  var i = va.call(e);
  return n && (t ? e[vt] = r : delete e[vt]), i;
}
function Rd(e) {
  return va.call(e);
}
var Ld = 20;
function Pd() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = Ea(r, e.shift(), 0, n);
  return r;
}
function Ir(e) {
  return Fe(e) ? e.slice() : e;
}
function Ea(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Ld)) {
    if (r++, Be(e) || Be(t) || ga(t))
      i = Ir(t);
    else if (Fe(e)) {
      if (i = e.slice(), Fe(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Ir(t[o]));
      else if (Jt(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = Ir(t[c]);
        }
    } else if (Jt(e))
      if (Jt(t)) {
        if (!Nd(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Be(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var f = i[c], l = s;
            if (vi(e, c, n) || vi(t, c, n))
              delete i[c];
            else {
              if (Jt(f) && Jt(l)) {
                var d = n.get(f) || [], h = n.get(l) || [];
                d.push({ obj: e, key: c }), h.push({ obj: t, key: c }), n.set(f, d), n.set(l, h);
              }
              i[c] = Ea(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function vi(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function Fe(e) {
  return Array.isArray(e);
}
function ga(e) {
  return typeof e == "function";
}
function Jt(e) {
  return !Be(e) && !Fe(e) && !ga(e) && typeof e == "object";
}
function Be(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function Nd(e, t) {
  return !(!_i(e) || !_i(t));
}
function Id(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
var Cd = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), Md = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, xd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Dd = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new Cd();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, xd([this._that], Md(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
), Ud = "exception", ln = function() {
  return ln = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ln.apply(this, arguments);
}, Bd = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ei = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, kd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Gd = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, f) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: He.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var l = Date.now();
      this._performanceStartTime = Ut.now(), this._performanceOffset = l - (this._performanceStartTime + Dn()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : l), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, f != null && this.setAttributes(f), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (v.warn("Invalid attribute key: " + t), this) : aa(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (v.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = Bd(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = Ei(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return v.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && v.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), li(r) && (li(n) || (n = r), r = void 0);
      var i = xe(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, kd([], Ei(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = ln({}, t), this.status.message != null && typeof t.message != "string" && (v.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        v.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = Jl(this.startTime, this.endTime), this._duration[0] < 0 && (v.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && v.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= Ut.now())
        return la(t + this._performanceOffset);
      if (typeof t == "number")
        return ct(t);
      if (t instanceof Date)
        return ct(t.getTime());
      if (Un(t))
        return t;
      if (this._startTimeProvided)
        return ct(Date.now());
      var r = Ut.now() - this._performanceStartTime;
      return da(this.startTime, ct(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[Lr] = t : t && (t.code ? n[Rr] = t.code.toString() : t.name && (n[Rr] = t.name), t.message && (n[Lr] = t.message), t.stack && (n[Xl] = t.stack)), n[Rr] || n[Lr] ? this.addEvent(Ud, n, r) : v.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && v.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substring(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (v.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), Gt;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Gt || (Gt = {}));
var Xe = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Gt.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), Bt = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Gt.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), Cr = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (kt(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new Bt()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new Bt(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new Xe(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new Bt(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new Xe();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var u = A.getSpanContext(t);
      return !u || !ve(u) ? this._root.shouldSample(t, r, n, i, o, a) : u.isRemote ? u.traceFlags & J.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : u.traceFlags & J.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), gi = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: Vo(r) && this._accumulate(r) < this._upperBound ? Gt.RECORD_AND_SAMPLED : Gt.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), Hd = W.AlwaysOn, It = 1;
function ya() {
  var e = ue();
  return {
    sampler: ma(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function ma(e) {
  switch (e === void 0 && (e = ue()), e.OTEL_TRACES_SAMPLER) {
    case W.AlwaysOn:
      return new Bt();
    case W.AlwaysOff:
      return new Xe();
    case W.ParentBasedAlwaysOn:
      return new Cr({
        root: new Bt()
      });
    case W.ParentBasedAlwaysOff:
      return new Cr({
        root: new Xe()
      });
    case W.TraceIdRatio:
      return new gi(yi(e));
    case W.ParentBasedTraceIdRatio:
      return new Cr({
        root: new gi(yi(e))
      });
    default:
      return v.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + Hd + '".'), new Bt();
  }
}
function yi(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return v.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + It + "."), It;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + It + "."), It) : t < 0 || t > 1 ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + It + "."), It) : t;
}
function $d(e) {
  var t = {
    sampler: ma()
  }, r = ya(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function jd(e) {
  var t, r, n, i, o, a, u, c, s, f, l, d, h = Object.assign({}, e.spanLimits), _ = Gl();
  return h.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : _.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : _.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Ue, h.attributeValueLengthLimit = (d = (l = (f = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = e.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && f !== void 0 ? f : _.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && l !== void 0 ? l : _.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : De, Object.assign({}, e, { spanLimits: h });
}
var Vd = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = ue();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new Dd(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (v.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || t.spanContext().traceFlags & J.SAMPLED && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && v.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (v.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        O.with(ul(O.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(l) {
              var d;
              clearTimeout(i), l.code === cn.SUCCESS ? r() : n((d = l.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var f = o[c];
            f.resource.asyncAttributesPending && f.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(f.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(l) {
            kt(l), n(l);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, kt(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Fd = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ta = (
  /** @class */
  function(e) {
    Fd(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          kt(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          kt(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(Vd)
), Xd = 8, zd = 16, Wd = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = mi(zd), this.generateSpanId = mi(Xd);
    }
    return e;
  }()
), Oe = Array(32);
function mi(e) {
  return function() {
    for (var r = 0; r < e * 2; r++)
      Oe[r] = Math.floor(Math.random() * 16) + 48, Oe[r] >= 58 && (Oe[r] += 39);
    return String.fromCharCode.apply(null, Oe.slice(0, e * 2));
  };
}
var qd = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = $d(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new Wd(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = O.active()), r.root && (n = A.deleteSpan(n));
      var u = A.getSpan(n);
      if (xn(n)) {
        v.debug("Instrumentation suppressed, returning Noop Span");
        var c = A.wrapSpanContext($o);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), f = this._idGenerator.generateSpanId(), l, d, h;
      !s || !A.isSpanContextValid(s) ? l = this._idGenerator.generateTraceId() : (l = s.traceId, d = s.traceState, h = s.spanId);
      var _ = (i = r.kind) !== null && i !== void 0 ? i : se.INTERNAL, p = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(B) {
        return {
          context: B.context,
          attributes: xe(B.attributes)
        };
      }), E = xe(r.attributes), g = this._sampler.shouldSample(n, l, t, _, E, p);
      d = (a = g.traceState) !== null && a !== void 0 ? a : d;
      var y = g.decision === Ge.RECORD_AND_SAMPLED ? J.SAMPLED : J.NONE, b = { traceId: l, spanId: f, traceFlags: y, traceState: d };
      if (g.decision === Ge.NOT_RECORD) {
        v.debug("Recording is off, propagating context in a non-recording span");
        var c = A.wrapSpanContext(b);
        return c;
      }
      var L = xe(Object.assign(E, g.attributes)), G = new Gd(this, n, t, b, _, h, p, r.startTime, void 0, L);
      return G;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : O.active(), s = this.startSpan(t, o, c), f = A.setSpan(c, s);
        return O.with(f, u, void 0, s);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
), Yd = "process.runtime.name", Kd = "service.name", Jd = "telemetry.sdk.name", Zd = "telemetry.sdk.language", Qd = "telemetry.sdk.version", tp = Yd, ep = Kd, dn = Jd, pn = Zd, hn = Qd, rp = "webjs", np = rp, ip = "1.30.1", Ct, Mr = (Ct = {}, Ct[dn] = "opentelemetry", Ct[tp] = "browser", Ct[pn] = np, Ct[hn] = ip, Ct);
function op() {
  return "unknown_service";
}
var st = function() {
  return st = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, st.apply(this, arguments);
}, ap = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, sp = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, up = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ce = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return v.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[ep] = op(), t[pn] = Mr[pn], t[dn] = Mr[dn], t[hn] = Mr[hn], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && v.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return ap(this, void 0, void 0, function() {
        return sp(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = st(st({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = up(a, 2), s = c[0], f = c[1];
        return st(st(st(st({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), f);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), Ae = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ti = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = Ae(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          kt(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = Ae(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = Ae(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = Ae(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, e;
  }()
), cp = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), fp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, lp = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Et;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(Et || (Et = {}));
var dp = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = Pd({}, ya(), jd(t));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : ce.empty(), i.mergeResourceWithDefaults && (this.resource = ce.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = t.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = lp([], fp(t.spanProcessors), !1), this.activeSpanProcessor = new Ti(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new Ta(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new cp();
      }
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new qd({ name: t, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return v.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new Ti(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), A.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && O.setGlobalContextManager(t.contextManager), t.propagator && D.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = Et.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== Et.timeout && (o = Et.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = Et.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(u) {
            return u !== Et.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(ue().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || v.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new Ql({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = ue().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || v.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new vd();
      }],
      ["baggage", function() {
        return new El();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), pp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, hp = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Sa = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = ht;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = ht);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = ht, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = ht, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || ht;
      try {
        return r.call.apply(r, hp([n], pp(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), _p = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), vp = (
  /** @class */
  function(e) {
    _p(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new Sa()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(dp)
), m;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(m || (m = {}));
var xr;
function Ep() {
  return xr || (xr = document.createElement("a")), xr;
}
function dt(e, t) {
  return t in e;
}
function N(e, t, r, n) {
  var i = void 0, o = void 0;
  dt(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = m.FETCH_START;
  if (dt(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function Ht(e, t, r) {
  r === void 0 && (r = !1), r || (N(e, m.FETCH_START, t), N(e, m.DOMAIN_LOOKUP_START, t), N(e, m.DOMAIN_LOOKUP_END, t), N(e, m.CONNECT_START, t), dt(t, "name") && t.name.startsWith("https:") && N(e, m.SECURE_CONNECTION_START, t), N(e, m.CONNECT_END, t), N(e, m.REQUEST_START, t), N(e, m.RESPONSE_START, t), N(e, m.RESPONSE_END, t));
  var n = t[m.ENCODED_BODY_SIZE];
  n !== void 0 && e.setAttribute(zl, n);
  var i = t[m.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && e.setAttribute(Wl, i);
}
function gp(e) {
  return e.slice().sort(function(t, r) {
    var n = t[m.FETCH_START], i = r[m.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function Oa() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function Aa(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = tt(e);
  e = a.toString();
  var u = mp(e, t, r, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = gp(u);
  if (a.origin !== Oa() && c.length > 1) {
    var s = c[0], f = yp(c, s[m.RESPONSE_END], r), l = s[m.RESPONSE_END], d = f[m.FETCH_START];
    return d < l && (f = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: f
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function yp(e, t, r) {
  for (var n = ft(r), i = ft(ee(t)), o = e[1], a, u = e.length, c = 1; c < u; c++) {
    var s = e[c], f = ft(ee(s[m.FETCH_START])), l = ft(ee(s[m.RESPONSE_END])), d = n - l;
    f >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function mp(e, t, r, n, i, o) {
  var a = ft(t), u = ft(r), c = n.filter(function(s) {
    var f = ft(ee(s[m.FETCH_START])), l = ft(ee(s[m.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === e && f >= a && l <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function tt(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = Ep();
  return t.href = e, t;
}
function ba(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = Sp(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += ba(e.parentNode, !1)), n += r, n;
}
function Tp(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function Sp(e, t) {
  var r = e.nodeType, n = Tp(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function wa(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = tt(e);
  return n.origin === Oa() ? !0 : r.some(function(i) {
    return Id(e, i);
  });
}
var _n = function() {
  return _n = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, _n.apply(this, arguments);
}, Op = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = C.wrap, this._unwrap = C.unwrap, this._massWrap = C.massWrap, this._massUnwrap = C.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = A.getTracer(t, r), this._meter = $t.getMeter(t, r), this._logger = Ee.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = _n({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Ap = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bp = (
  /** @class */
  function(e) {
    Ap(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Op)
);
function Si(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
var re;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(re || (re = {}));
var wp = "0.44.0", Rp = "@opentelemetry/instrumentation-document-load";
const Lp = "http.url", Pp = "http.user_agent", ne = Lp, Np = Pp;
var ze;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(ze || (ze = {}));
var Ip = function() {
  var e, t, r = {}, n = (t = (e = je).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(m);
    i.forEach(function(u) {
      if (dt(n, u)) {
        var c = n[u];
        typeof c == "number" && (r[u] = c);
      }
    });
  } else {
    var o = je, a = o.timing;
    if (a) {
      var i = Object.values(m);
      i.forEach(function(c) {
        if (dt(a, c)) {
          var s = a[c];
          typeof s == "number" && (r[c] = s);
        }
      });
    }
  }
  return r;
}, Oi = {
  "first-paint": ze.FIRST_PAINT,
  "first-contentful-paint": ze.FIRST_CONTENTFUL_PAINT
}, Cp = function(e) {
  var t, r, n = (r = (t = je).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    dt(Oi, o) && e.addEvent(Oi[o], a);
  });
}, Mp = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), xp = (
  /** @class */
  function(e) {
    Mp(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, Rp, wp, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = je).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === sl;
      }), i = Ip(), o = n && n.content || "";
      O.with(D.extract(ht, { traceparent: o }), function() {
        var a, u = r._startSpan(re.DOCUMENT_LOAD, m.FETCH_START, i);
        u && (O.with(A.setSpan(O.active(), u), function() {
          var c = r._startSpan(re.DOCUMENT_FETCH, m.FETCH_START, i);
          c && (c.setAttribute(ne, location.href), O.with(A.setSpan(O.active(), c), function() {
            var s;
            r.getConfig().ignoreNetworkEvents || Ht(c, i), r._addCustomAttributesOnSpan(c, (s = r.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), r._endSpan(c, m.RESPONSE_END, i);
          }));
        }), u.setAttribute(ne, location.href), u.setAttribute(Np, navigator.userAgent), r._addResourcesSpans(u), r.getConfig().ignoreNetworkEvents || (N(u, m.FETCH_START, i), N(u, m.UNLOAD_EVENT_START, i), N(u, m.UNLOAD_EVENT_END, i), N(u, m.DOM_INTERACTIVE, i), N(u, m.DOM_CONTENT_LOADED_EVENT_START, i), N(u, m.DOM_CONTENT_LOADED_EVENT_END, i), N(u, m.DOM_COMPLETE, i), N(u, m.LOAD_EVENT_START, i), N(u, m.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || Cp(u), r._addCustomAttributesOnSpan(u, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(u, m.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (dt(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(re.RESOURCE_FETCH, m.FETCH_START, r, n);
      o && (o.setAttribute(ne, r.name), this.getConfig().ignoreNetworkEvents || Ht(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, m.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (dt(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? A.setSpan(O.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && Si(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && Si(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(bp)
), vn = function() {
  return vn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, vn.apply(this, arguments);
}, Dp = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = C.wrap, this._unwrap = C.unwrap, this._massWrap = C.massWrap, this._massUnwrap = C.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = A.getTracer(t, r), this._meter = $t.getMeter(t, r), this._logger = Ee.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = vn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Up = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Bp = (
  /** @class */
  function(e) {
    Up(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Dp)
);
function kp(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function Gp(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Dr = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, En = performance, Hp = "http.method", $p = "http.url", jp = "http.host", Vp = "http.scheme", Fp = "http.status_code", Xp = "http.user_agent", zp = "http.request_content_length_uncompressed", Wp = Hp, qp = $p, Yp = jp, Kp = Vp, Jp = Fp, Zp = Xp, Qp = zp, th = 9, eh = 6, rh = Math.pow(10, eh), Ai = Math.pow(10, th);
function gn(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * rh);
  return [r, n];
}
function nh() {
  var e = En.timeOrigin;
  if (typeof e != "number") {
    var t = En;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function bi(e) {
  var t = gn(nh()), r = gn(En.now());
  return ih(t, r);
}
function ih(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= Ai && (r[1] -= Ai, r[0] += 1), r;
}
var oh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function ah(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function sh(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = oh(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (ah(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var We;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(We || (We = {}));
var uh = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, ch = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, fh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, lh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ra = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function dh() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var r = e[1];
    if (!(r != null && r.body))
      return Promise.resolve();
    if (r.body instanceof ReadableStream) {
      var n = ph(r.body), i = n.body, o = n.length;
      return r.body = i, o;
    } else
      return Promise.resolve(hh(r.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return yn(u);
    }) : Promise.resolve();
  }
}
function ph(e) {
  if (!e.pipeThrough)
    return Ra.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, r, n = new Promise(function(o) {
    r = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return uh(this, void 0, void 0, function() {
        var u;
        return ch(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      r(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: n
  };
}
function hh(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return vh(e);
  if (e instanceof URLSearchParams)
    return yn(e.toString());
  if (typeof e == "string")
    return yn(e);
  Ra.warn("unknown body type");
}
var _h = new TextEncoder();
function yn(e) {
  return _h.encode(e).byteLength;
}
function vh(e) {
  var t, r, n = 0;
  try {
    for (var i = fh(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = lh(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var wi = "0.57.2", Eh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), gh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, yh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ur, mh = 300, Ri = typeof process == "object" && ((Ur = process.release) === null || Ur === void 0 ? void 0 : Ur.name) === "node", Th = (
  /** @class */
  function(e) {
    Eh(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", wi, r) || this;
      return n.component = "fetch", n.version = wi, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[m.FETCH_START]
      }, A.setSpan(O.active(), r));
      Ht(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[m.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = tt(n.url);
      r.setAttribute(Jp, n.status), n.statusText != null && r.setAttribute(We.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Yp, i.host), r.setAttribute(Kp, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(Zp, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!wa(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        D.inject(O.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        D.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Headers)
        D.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Map)
        D.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        D.inject(O.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), sh(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: se.CLIENT,
        attributes: (i = {}, i[We.COMPONENT] = this.moduleName, i[Wp] = o, i[qp] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = Aa(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(r, c), this._markResourceAsUsed(c)), Ht(r, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = gn(Date.now()), u = bi();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(r, n, u), o._tasksCount--, o._clearResources(), r.end(a);
      }, mh);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = tt(a[0] instanceof Request ? a[0].url : String(a[0])).href, f = a[0] instanceof Request ? a[0] : a[1] || {}, l = i._createSpan(s, f);
          if (!l)
            return n.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && dh.apply(void 0, yh([], gh(a), !1)).then(function(g) {
            g && l.setAttribute(Qp, g);
          }).catch(function(g) {
            i._diag.warn("getFetchBodyLength", g);
          });
          function h(g, y) {
            i._applyAttributesAfterFetch(g, f, y), i._endSpan(g, d, {
              status: y.status || 0,
              statusText: y.message,
              url: s
            });
          }
          function _(g, y) {
            i._applyAttributesAfterFetch(g, f, y), y.status >= 200 && y.status < 400 ? i._endSpan(g, d, y) : i._endSpan(g, d, {
              status: y.status,
              statusText: y.statusText,
              url: s
            });
          }
          function p(g, y, b) {
            try {
              var L = b.clone(), G = b.clone(), B = L.body;
              if (B) {
                var Lt = B.getReader(), Vt = function() {
                  Lt.read().then(function(Pt) {
                    var H = Pt.done;
                    H ? _(g, G) : Vt();
                  }, function(Pt) {
                    h(g, Pt);
                  });
                };
                Vt();
              } else
                _(g, b);
            } finally {
              y(b);
            }
          }
          function E(g, y, b) {
            try {
              h(g, b);
            } finally {
              y(b);
            }
          }
          return new Promise(function(g, y) {
            return O.with(A.setSpan(O.active(), l), function() {
              return i._addHeaders(f, s), i._tasksCount++, n.apply(c, f instanceof Request ? [f] : [s, f]).then(p.bind(c, l, g), E.bind(c, l, y));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && kp(function() {
        return a(r, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(r) {
      var n = bi(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === r && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (Ri) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      Gp(fetch) && (this._unwrap(Dr, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(Dr, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      Ri || (this._unwrap(Dr, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(Bp)
), mn = function() {
  return mn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, mn.apply(this, arguments);
}, Sh = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = C.wrap, this._unwrap = C.unwrap, this._massWrap = C.massWrap, this._massUnwrap = C.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = A.getTracer(t, r), this._meter = $t.getMeter(t, r), this._logger = Ee.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = mn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Oh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ah = (
  /** @class */
  function(e) {
    Oh(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Sh)
);
function bh(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function Li(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var fe = performance, wh = "http.method", Rh = "http.url", Lh = "http.host", Ph = "http.scheme", Nh = "http.status_code", Ih = "http.user_agent", Ch = "http.request_content_length_uncompressed", Mh = wh, xh = Rh, Dh = Lh, Uh = Ph, Bh = Nh, kh = Ih, Gh = Ch, Hh = 9, $h = 6, jh = Math.pow(10, $h), Pi = Math.pow(10, Hh);
function Ni(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * jh);
  return [r, n];
}
function Vh() {
  var e = fe.timeOrigin;
  if (typeof e != "number") {
    var t = fe;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Ii(e) {
  var t = Ni(Vh()), r = Ni(fe.now());
  return Fh(t, r);
}
function Fh(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= Pi && (r[1] -= Pi, r[0] += 1), r;
}
var Xh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function zh(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function Wh(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = Xh(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (zh(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var Q;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(Q || (Q = {}));
var qh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Yh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Kh = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Jh(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return Qh(e);
  if (e instanceof URLSearchParams)
    return Ci(e.toString());
  if (typeof e == "string")
    return Ci(e);
  Kh.warn("unknown body type");
}
var Zh = new TextEncoder();
function Ci(e) {
  return Zh.encode(e).byteLength;
}
function Qh(e) {
  var t, r, n = 0;
  try {
    for (var i = qh(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Yh(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var Mi = "0.57.2", Tn;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(Tn || (Tn = {}));
var t_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), e_ = 300, r_ = (
  /** @class */
  function(e) {
    t_(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", Mi, r) || this;
      return n.component = "xml-http-request", n.version = Mi, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = tt(n).href;
      if (!wa(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        D.inject(O.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      D.inject(O.active(), a), Object.keys(a).forEach(function(u) {
        r.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      O.with(A.setSpan(O.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[m.FETCH_START]
        });
        Ht(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[m.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = tt(i);
        n.status !== void 0 && r.setAttribute(Bh, n.status), n.statusText !== void 0 && r.setAttribute(Tn.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Dh, o.host), r.setAttribute(Uh, o.protocol.replace(":", "")), r.setAttribute(kh, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && bh(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = tt(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (fe.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var u = r.createdResources.entries;
        (!u || !u.length) && (u = fe.getEntriesByType("resource"));
        var c = Aa(tt(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var f = c.corsPreFlightRequest;
          f && (this._addChildSpan(n, f), this._markResourceAsUsed(f)), Ht(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (Wh(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: se.CLIENT,
        attributes: (o = {}, o[Mh] = i, o[xh] = tt(n).toString(), o)
      });
      return u.addEvent(Q.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: u,
        spanUrl: n
      }), u;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(f, l, d, h) {
        var _ = l.callbackToRemoveEvents;
        typeof _ == "function" && _();
        var p = l.span, E = l.spanUrl, g = l.sendStartTime;
        p && (r._findResourceAndAddNetworkEvents(l, p, E, g, d), p.addEvent(f, h), r._addFinalSpanAttributes(p, l, E), p.end(h), r._tasksCount--), r._clearResources();
      }
      function i(f, l) {
        var d = r._xhrMem.get(l);
        if (d) {
          d.status = l.status, d.statusText = l.statusText, r._xhrMem.delete(l), d.span && r._applyAttributesAfterXHR(d.span, l);
          var h = Ii(), _ = Date.now();
          setTimeout(function() {
            n(f, d, h, _);
          }, e_);
        }
      }
      function o() {
        i(Q.EVENT_ERROR, this);
      }
      function a() {
        i(Q.EVENT_ABORT, this);
      }
      function u() {
        i(Q.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(Q.EVENT_LOAD, this) : i(Q.EVENT_ERROR, this);
      }
      function s(f) {
        f.removeEventListener("abort", a), f.removeEventListener("error", o), f.removeEventListener("load", c), f.removeEventListener("timeout", u);
        var l = r._xhrMem.get(f);
        l && (l.callbackToRemoveEvents = void 0);
      }
      return function(f) {
        return function() {
          for (var d = this, h = [], _ = 0; _ < arguments.length; _++)
            h[_] = arguments[_];
          var p = r._xhrMem.get(this);
          if (!p)
            return f.apply(this, h);
          var E = p.span, g = p.spanUrl;
          if (E && g) {
            if (r.getConfig().measureRequestSize && (h != null && h[0])) {
              var y = h[0], b = Jh(y);
              b !== void 0 && E.setAttribute(Gh, b);
            }
            O.with(A.setSpan(O.active(), E), function() {
              r._tasksCount++, p.sendStartTime = Ii(), E.addEvent(Q.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), p.callbackToRemoveEvents = function() {
                s(d), p.createdResources && p.createdResources.observer.disconnect();
              }, r._addHeaders(d, g), r._addResourceObserver(d, g);
            });
          }
          return f.apply(this, h);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), Li(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), Li(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(Ah)
);
const xi = (e, t, r) => {
  const n = Bn(
    t,
    e.headers,
    r
  );
  return P(S({}, e), {
    headers: n
  });
}, Bn = (e, t, r) => {
  var i, o;
  const n = S({}, t);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...n_, ...e].includes(
      a == null ? void 0 : a.toLowerCase()
    ) && (n[a] = "[REDACTED]");
  }), n);
}, n_ = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], i_ = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], o_ = [
  "awsaccesskeyid",
  "signature",
  "sig",
  "x-goog-signature"
], La = (e) => {
  var t, r;
  try {
    return new URL(e);
  } catch (n) {
    return new URL(e, (r = (t = globalThis.location) == null ? void 0 : t.origin) != null ? r : "http://example.com");
  }
}, Pa = (e) => {
  try {
    const t = La(e);
    (t.username || t.password) && (t.username = "REDACTED", t.password = "REDACTED");
    const r = t.searchParams;
    if (o_.forEach((n) => {
      for (const i of Array.from(r.keys()))
        i.toLowerCase() === n && r.set(i, "REDACTED");
    }), !e.includes("://") && !e.startsWith("//"))
      return t.pathname + t.search + t.hash;
    if (e.startsWith("//")) {
      let n = "//";
      return (t.username || t.password) && (n += t.username + ":" + t.password + "@"), n += t.host + t.pathname + t.search + t.hash, n;
    }
    return t.toString();
  } catch (t) {
    return e;
  }
}, a_ = new RegExp("sdk\\/evalx\\/[^/]+\\/contexts\\/(?<context>[^/?]*)\\??.*?"), s_ = new RegExp("\\/eval\\/[^/]+\\/(?<context>[^/?]*)\\??.*?");
function u_(e) {
  return !!(e.includes("/sdk/evalx") && e.match(a_) || e.includes("/eval/") && e.match(s_));
}
const Na = "X-Highlight-Request", Di = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, c_ = (e, {
  headersToRedact: t,
  headersToRecord: r,
  requestResponseSanitizer: n
}) => {
  var c, s;
  let i = e;
  if (n) {
    let l = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (h) {
      l = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(
        i.response.body
      );
    } catch (h) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (h) {
    } finally {
      l = l && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), l && (i.request.body = JSON.stringify(
        i.request.body
      )), d && (i.response.body = JSON.stringify(
        i.response.body
      ));
    }
    if (!i)
      return null;
  }
  const f = i, { request: o, response: a } = f, u = sr(f, ["request", "response"]);
  return S({
    request: xi(o, t, r),
    response: xi(a, t, r)
  }, u);
}, Cy = (e, t, r, n) => {
  e.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((c, s) => {
    const f = Di(s.name);
    return s.initiatorType === r ? c[r][f] = [
      ...c[r][f] || [],
      s
    ] : c.others[f] = [
      ...c.others[f] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = t.reduce(
    (c, s) => {
      const f = Di(s.request.url);
      return c[f] = [...c[f] || [], s], c;
    },
    a
  );
  for (let c in o[r]) {
    const s = o[r][c], f = a[c];
    if (!f)
      continue;
    const l = Math.max(
      s.length - f.length,
      0
    );
    for (let d = l; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = f[d - l]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce(
    (c, s) => {
      let f = s.requestResponsePair;
      return f && (f = c_(
        s.requestResponsePair,
        n
      ), !f) || (s.toJSON = function() {
        const l = window.performance.timeOrigin;
        return {
          initiatorType: this.initiatorType,
          startTimeAbs: l + this.startTime,
          connectStartAbs: l + this.connectStart,
          connectEndAbs: l + this.connectEnd,
          domainLookupStartAbs: l + this.domainLookupStart,
          domainLookupEndAbs: l + this.domainLookupEnd,
          fetchStartAbs: l + this.fetchStart,
          redirectStartAbs: l + this.redirectStart,
          redirectEndAbs: l + this.redirectEnd,
          requestStartAbs: l + this.requestStart,
          responseStartAbs: l + this.responseStart,
          responseEndAbs: l + this.responseEnd,
          secureConnectionStartAbs: l + this.secureConnectionStart,
          workerStartAbs: l + this.workerStart,
          name: this.name,
          transferSize: this.transferSize,
          encodedBodySize: this.encodedBodySize,
          decodedBodySize: this.decodedBodySize,
          nextHopProtocol: this.nextHopProtocol,
          requestResponsePairs: f
        };
      }, c.push(s)), c;
    },
    []
  );
}, f_ = (e) => ["events.ld.catamorphic.com", "events.launchdarkly.com"].some(
  (t) => e.toLocaleLowerCase().includes(t)
), l_ = (e) => u_(e), d_ = (e, t) => t.some(
  (r) => e.toLocaleLowerCase().includes(r)
), kn = (e, t, r) => !d_(e, t) && !l_(e) && !f_(e), Gn = (e, t, r) => {
  var o;
  if (r.some(
    (a) => e.toLowerCase().includes(a)
  ))
    return !1;
  let n = [];
  t === !0 ? (n = ["localhost", /^\//], (o = window == null ? void 0 : window.location) != null && o.host && n.push(window.location.host)) : t instanceof Array && (n = t);
  let i = !1;
  return n.forEach((a) => {
    e.match(a) && (i = !0);
  }), i;
};
function p_(e) {
  for (var t = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < e; i++)
    t += r.charAt(
      Math.floor(Math.random() * n)
    );
  return t;
}
const Ia = () => {
  const e = p_(10), t = Xg(), r = t == null ? void 0 : t.spanContext().traceId;
  return [at(), r != null ? r : e];
}, Ca = (e, t) => e + "/" + t, My = (e, t, r, n, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(f, l) {
    return typeof l == "string" ? this._url = l : this._url = l.toString(), this._method = f, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some(
      (d) => this._url.toLowerCase().includes(d)
    ), u.apply(this, arguments);
  }, a.setRequestHeader = function(f, l) {
    return this._requestHeaders[f] = l, s.apply(this, arguments);
  }, a.send = function(f) {
    if (!kn(
      this._url,
      t
    ))
      return c.apply(this, arguments);
    const [l, d] = Ia();
    Gn(
      this._url,
      r,
      n
    ) && this.setRequestHeader(
      Na,
      Ca(l, d)
    );
    const h = this._shouldRecordHeaderAndBody, _ = {
      sessionSecureID: l,
      id: d,
      url: this._url,
      verb: this._method,
      headers: h ? this._requestHeaders : {},
      body: void 0
    };
    if (h && f) {
      const p = Ui(f, _.url);
      p && (this._body = p, _.body = et(
        p,
        i,
        o,
        _.headers
      ));
    }
    return this.addEventListener("load", function() {
      return k(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (h) {
          const y = this.getAllResponseHeaders().trim().split(/[\r\n]+/), b = {};
          if (y.forEach(function(L) {
            const G = L.split(": "), B = G.shift();
            b[B] = G.join(": ");
          }), p.headers = b, f) {
            const L = Ui(f, _.url);
            L && (_.body = et(
              L,
              i,
              o,
              p.headers
            ));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = et(
              this.responseText,
              i,
              o,
              p.headers
            ), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const L = yield this.response.text();
                p.body = et(
                  L,
                  i,
                  o,
                  p.headers
                ), p.size = this.response.size;
              } catch (L) {
              }
          } else
            try {
              p.body = et(
                this.response,
                i,
                o,
                p.headers
              );
            } catch (L) {
            }
        }
        e({
          request: _,
          response: p,
          urlBlocked: !h
        });
      });
    }), this.addEventListener("error", function() {
      return k(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: _,
          response: p,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, Ui = (e, t) => {
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && (e.includes("pushPayload") || e.includes("pushSessionEvents"))))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return Dt(e);
  return null;
}, Bi = 64 * 1024, h_ = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, et = (e, t, r, n) => {
  var o, a, u;
  let i = Bi;
  if (n) {
    let c = "";
    typeof n.get == "function" ? c = (o = n.get("content-type")) != null ? o : "" : c = (a = n["content-type"]) != null ? a : "";
    try {
      c = c.split(";")[0];
    } catch (s) {
    }
    i = (u = h_[c]) != null ? u : Bi;
  }
  if (e) {
    if (t)
      try {
        const c = JSON.parse(e);
        Array.isArray(c) ? c.forEach((s) => {
          Object.keys(s).forEach((f) => {
            t.includes(
              f.toLocaleLowerCase()
            ) && (s[f] = "[REDACTED]");
          });
        }) : Object.keys(c).forEach((s) => {
          t.includes(s.toLocaleLowerCase()) && (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
    if (r)
      try {
        const c = JSON.parse(e);
        Object.keys(c).forEach((s) => {
          r.includes(s.toLocaleLowerCase()) || (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (c) {
  }
  return e;
}, xy = (e, t, r, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: f } = __(u, c);
    if (!kn(
      f,
      t
    ))
      return a.call(this, u, c);
    const [l, d] = Ia();
    if (Gn(f, r, n)) {
      c = c || {};
      let E = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(
        ([g, y]) => E.set(g, y)
      ), E.set(
        Na,
        Ca(l, d)
      ), c.headers = Object.fromEntries(E.entries());
    }
    const h = {
      sessionSecureID: l,
      id: d,
      headers: {},
      body: void 0,
      url: f,
      verb: s
    }, _ = !n.some(
      (E) => f.toLowerCase().includes(E)
    );
    _ && (h.headers = Object.fromEntries(
      new Headers(c == null ? void 0 : c.headers).entries()
    ), h.body = et(
      c == null ? void 0 : c.body,
      i,
      o,
      c == null ? void 0 : c.headers
    ));
    let p = a.call(this, u, c);
    return v_(
      p,
      h,
      e,
      _,
      i,
      o
    ), p;
  }, () => {
    window._fetchProxy = a;
  };
}, __ = (e, t) => {
  const r = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let n;
  return typeof e == "object" ? "url" in e && e.url ? n = e.url : n = e.toString() : n = e, {
    method: r,
    url: n
  };
}, v_ = (e, t, r, n, i, o) => {
  const a = (u) => k(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, f = !n;
    "stack" in u || u instanceof Error ? (c = P(S({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = P(S({}, c), {
      status: u.status
    }), n && (c.body = yield Ma(
      u,
      o,
      i
    ), c.headers = Object.fromEntries(
      u.headers.entries()
    ), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (f = !0, c = P(S({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && r({
      request: t,
      response: c,
      urlBlocked: f
    });
  });
  e.then(a).catch(() => {
  });
}, Ma = (e, t, r) => k(void 0, null, function* () {
  let n;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c, s = "";
      for (; !(c = yield a.read()).done; ) {
        let f = c.value;
        s += u.decode(f);
      }
      n = s, n = et(
        n,
        r,
        t,
        e.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var xa = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, r) {
      this._delegate.export(t, r);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), E_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ki = (
  /** @class */
  function(e) {
    E_(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
);
function g_(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function y_(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function m_(e, t, r) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: g_((i = (n = e.timeoutMillis) !== null && n !== void 0 ? n : t.timeoutMillis) !== null && i !== void 0 ? i : r.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : r.concurrencyLimit,
    compression: (c = (u = e.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function T_() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var S_ = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, O_ = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, A_ = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var n = function() {
        var i = r._sendingPromises.indexOf(t);
        r._sendingPromises.splice(i, 1);
      };
      t.then(n, n);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return S_(this, void 0, void 0, function() {
        return O_(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function b_(e) {
  return new A_(e.concurrencyLimit);
}
function w_(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function R_() {
  return {
    handleResponse: function(e) {
      e == null || !w_(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || v.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var L_ = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, P_ = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, N_ = (
  /** @class */
  function() {
    function e(t, r, n, i, o) {
      this._transport = t, this._serializer = r, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = v.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, r) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        r({
          code: x.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        r({
          code: x.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          r({
            code: x.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          r({
            code: x.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? r({
          code: x.FAILED,
          error: new ki("Export failed with retryable status")
        }) : r({
          code: x.FAILED,
          error: new ki("Export failed with unknown error")
        });
      }, function(o) {
        return r({
          code: x.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return L_(this, void 0, void 0, function() {
        return P_(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function I_(e, t) {
  return new N_(e.transport, e.serializer, R_(), e.promiseHandler, t.timeout);
}
function Da(e, t, r) {
  return I_({
    transport: r,
    serializer: t,
    promiseHandler: b_(e)
  }, { timeout: e.timeoutMillis });
}
function Gi(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function Hn(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = Gi(e.charCodeAt(n)), o = Gi(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var C_ = 9, M_ = Math.pow(10, C_);
function x_(e) {
  return e[0] * M_ + e[1];
}
function Ua(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function D_(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function Ba(e) {
  var t = Ua(e);
  return D_(t);
}
function U_(e) {
  var t = Ua(e);
  return t.toString();
}
var B_ = typeof BigInt != "undefined" ? U_ : x_;
function Hi(e) {
  return e;
}
function ka(e) {
  if (e !== void 0)
    return Hn(e);
}
var k_ = {
  encodeHrTime: Ba,
  encodeSpanContext: Hn,
  encodeOptionalSpanContext: ka
};
function Ga(e) {
  var t, r;
  if (e === void 0)
    return k_;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? Ba : B_,
    encodeSpanContext: i ? Hi : Hn,
    encodeOptionalSpanContext: i ? Hi : ka
  };
}
var G_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ha(e) {
  return {
    attributes: At(e.attributes),
    droppedAttributesCount: 0
  };
}
function $a(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function At(e) {
  return Object.keys(e).map(function(t) {
    return ja(t, e[t]);
  });
}
function ja(e, t) {
  return {
    key: e,
    value: Va(t)
  };
}
function Va(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(Va) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = G_(r, 2), i = n[0], o = n[1];
        return ja(i, o);
      })
    }
  } : {};
}
var X;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
})(X || (X = {}));
var Y;
(function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
})(Y || (Y = {}));
var H_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), $i = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, ji = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, $_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, j_ = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, V_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function F_(e) {
  return e != null;
}
function Fa(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(r) {
    return [r, e[r]];
  })));
}
function X_(e) {
  var t, r;
  return e.name + ":" + ((t = e.version) !== null && t !== void 0 ? t : "") + ":" + ((r = e.schemaUrl) !== null && r !== void 0 ? r : "");
}
var Xa = (
  /** @class */
  function(e) {
    H_(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return Object.setPrototypeOf(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function le(e, t) {
  var r, n = new Promise(function(o, a) {
    r = setTimeout(function() {
      a(new Xa("Operation timed out."));
    }, t);
  });
  return Promise.race([e, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
function z_(e) {
  return $i(this, void 0, void 0, function() {
    var t = this;
    return ji(this, function(r) {
      return [2, Promise.all(e.map(function(n) {
        return $i(t, void 0, void 0, function() {
          var i, o;
          return ji(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function W_(e) {
  return e.status === "rejected";
}
function Vi(e, t) {
  var r = [];
  return e.forEach(function(n) {
    r.push.apply(r, j_([], $_(t(n)), !1));
  }), r;
}
function q_(e, t) {
  var r, n;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = V_(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function Y_(e, t) {
  for (var r = 0, n = e.length - 1, i = e.length; n >= r; ) {
    var o = r + Math.trunc((n - r) / 2);
    e[o] < t ? r = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function K_(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
var Tt;
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(Tt || (Tt = {}));
var J_ = (
  /** @class */
  function() {
    function e() {
      this.kind = Tt.DROP;
    }
    return e.prototype.createAccumulation = function() {
    }, e.prototype.merge = function(t, r) {
    }, e.prototype.diff = function(t, r) {
    }, e.prototype.toMetricData = function(t, r, n, i) {
    }, e;
  }()
), T;
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(T || (T = {}));
function ot(e, t, r) {
  var n, i, o, a;
  return ev(e) || v.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: e,
    type: t,
    description: (n = r == null ? void 0 : r.description) !== null && n !== void 0 ? n : "",
    unit: (i = r == null ? void 0 : r.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = r == null ? void 0 : r.valueType) !== null && o !== void 0 ? o : lt.DOUBLE,
    advice: (a = r == null ? void 0 : r.advice) !== null && a !== void 0 ? a : {}
  };
}
function Z_(e, t) {
  var r, n;
  return {
    name: (r = e.name) !== null && r !== void 0 ? r : t.name,
    description: (n = e.description) !== null && n !== void 0 ? n : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function Q_(e, t) {
  return K_(e.name, t.name) && e.unit === t.unit && e.type === t.type && e.valueType === t.valueType;
}
var tv = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function ev(e) {
  return e.match(tv) != null;
}
var rv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function nv(e) {
  var t = e.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: e,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var Br = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = nv(r)), this.startTime = t, this._boundaries = r, this._recordMinMax = n, this._current = i;
    }
    return e.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var r = Y_(this._boundaries, t);
        this._current.buckets.counts[r] += 1;
      }
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), za = (
  /** @class */
  function() {
    function e(t, r) {
      this._boundaries = t, this._recordMinMax = r, this.kind = Tt.HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Br(t, this._boundaries, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, f = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), f = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, f = n.max) : i.hasMinMax && (s = i.min, f = i.max)), new Br(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: f
      });
    }, e.prototype.diff = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new Br(r.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: Y.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = rv(o, 2), u = a[0], c = a[1], s = c.toPointValue(), f = t.type === T.GAUGE || t.type === T.UP_DOWN_COUNTER || t.type === T.OBSERVABLE_GAUGE || t.type === T.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: f ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, e;
  }()
), kr = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Gr = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Fi = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      t === void 0 && (t = new iv()), r === void 0 && (r = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = r, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(e.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(r, n) {
        return t.at(n);
      });
    }, e.prototype.at = function(t) {
      var r = this.indexBase - this.indexStart;
      return t < r && (t += this.backing.length), t -= r, this.backing.countAt(t);
    }, e.prototype.incrementBucket = function(t, r) {
      this.backing.increment(t, r);
    }, e.prototype.decrementBucket = function(t, r) {
      this.backing.decrement(t, r);
    }, e.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, e.prototype.downscale = function(t) {
      this._rotate();
      for (var r = 1 + this.indexEnd - this.indexStart, n = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < r; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, e.prototype.clone = function() {
      return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, e.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, e.prototype._relocateBucket = function(t, r) {
      t !== r && this.incrementBucket(t, this.backing.emptyBucket(r));
    }, e;
  }()
), iv = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(e.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.countAt = function(t) {
      return this._counts[t];
    }, e.prototype.growTo = function(t, r, n) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, Gr([
        n,
        this._counts.length - r
      ], kr(this._counts.slice(r)), !1)), i.splice.apply(i, Gr([0, r], kr(this._counts.slice(0, r)), !1)), this._counts = i;
    }, e.prototype.reverse = function(t, r) {
      for (var n = Math.floor((t + r) / 2) - t, i = 0; i < n; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[r - i - 1], this._counts[r - i - 1] = o;
      }
    }, e.prototype.emptyBucket = function(t) {
      var r = this._counts[t];
      return this._counts[t] = 0, r;
    }, e.prototype.increment = function(t, r) {
      this._counts[t] += r;
    }, e.prototype.decrement = function(t, r) {
      this._counts[t] >= r ? this._counts[t] -= r : this._counts[t] = 0;
    }, e.prototype.clone = function() {
      return new e(Gr([], kr(this._counts), !1));
    }, e;
  }()
), ov = 52, av = 2146435072, sv = 1048575, $n = 1023, Wa = -$n + 1, qa = $n, Sn = Math.pow(2, -1022);
function Ya(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = (r & av) >> 20;
  return n - $n;
}
function Ka(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = t.getUint32(4), i = (r & sv) * Math.pow(2, 32);
  return i + n;
}
function On(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
function uv(e) {
  return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
}
var cv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), de = (
  /** @class */
  function(e) {
    cv(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), fv = (
  /** @class */
  function() {
    function e(t) {
      this._shift = -t;
    }
    return e.prototype.mapToIndex = function(t) {
      if (t < Sn)
        return this._minNormalLowerBoundaryIndex();
      var r = Ya(t), n = this._rightShift(Ka(t) - 1, ov);
      return r + n >> this._shift;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._minNormalLowerBoundaryIndex();
      if (t < r)
        throw new de("underflow: " + t + " is < minimum lower boundary: " + r);
      var n = this._maxNormalLowerBoundaryIndex();
      if (t > n)
        throw new de("overflow: " + t + " is > maximum lower boundary: " + n);
      return On(1, t << this._shift);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      var t = Wa >> this._shift;
      return this._shift < 2 && t--, t;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return qa >> this._shift;
    }, e.prototype._rightShift = function(t, r) {
      return Math.floor(t * Math.pow(2, -r));
    }, e;
  }()
), lv = (
  /** @class */
  function() {
    function e(t) {
      this._scale = t, this._scaleFactor = On(Math.LOG2E, t), this._inverseFactor = On(Math.LN2, -t);
    }
    return e.prototype.mapToIndex = function(t) {
      if (t <= Sn)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (Ka(t) === 0) {
        var r = Ya(t);
        return (r << this._scale) - 1;
      }
      var n = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._maxNormalLowerBoundaryIndex();
      if (t >= r) {
        if (t === r)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new de("overflow: " + t + " is > maximum lower boundary: " + r);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (t <= n) {
        if (t === n)
          return Sn;
        if (t === n - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new de("overflow: " + t + " is < minimum lower boundary: " + n);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      return Wa << this._scale;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return (qa + 1 << this._scale) - 1;
    }, e;
  }()
), Xi = -10, zi = 20, dv = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new lv(t - 10) : new fv(t - 10);
});
function Wi(e) {
  if (e > zi || e < Xi)
    throw new de("expected scale >= " + Xi + " && <= " + zi + ", got: " + e);
  return dv[e + 10];
}
var pv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, be = (
  /** @class */
  function() {
    function e(t, r) {
      this.low = t, this.high = r;
    }
    return e.combine = function(t, r) {
      return new e(Math.min(t.low, r.low), Math.max(t.high, r.high));
    }, e;
  }()
), hv = 20, _v = 160, Hr = 2, vv = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, f, l) {
      t === void 0 && (t = t), r === void 0 && (r = _v), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new Fi()), f === void 0 && (f = new Fi()), l === void 0 && (l = Wi(hv)), this.startTime = t, this._maxSize = r, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = f, this._mapping = l, this._maxSize < Hr && (v.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Hr), this._maxSize = Hr);
    }
    return e.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(e.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateByIncrement = function(t, r) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += r, t === 0) {
          this._zeroCount += r;
          return;
        }
        this._sum += t * r, t > 0 ? this._updateBuckets(this._positive, t, r) : this._updateBuckets(this._negative, -t, r);
      }
    }, e.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._mergeBuckets(this.positive, t, t.positive, r), this._mergeBuckets(this.negative, t, t.negative, r);
    }, e.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._diffBuckets(this.positive, t, t.positive, r), this._diffBuckets(this.negative, t, t.negative, r);
    }, e.prototype.clone = function() {
      return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, e.prototype._updateBuckets = function(t, r, n) {
      var i = this._mapping.mapToIndex(r), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(r);
      }
      this._incrementIndexBy(t, i, n);
    }, e.prototype._incrementIndexBy = function(t, r, n) {
      if (n !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = r), r < t.indexStart) {
          var i = t.indexEnd - r;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = r;
        } else if (r > t.indexEnd) {
          var i = r - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = r;
        }
        var o = r - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, n);
      }
    }, e.prototype._grow = function(t, r) {
      var n = t.backing.length, i = t.indexBase - t.indexStart, o = n - i, a = uv(r);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, e.prototype._changeScale = function(t, r) {
      for (var n = 0; t - r >= this._maxSize; )
        t >>= 1, r >>= 1, n++;
      return n;
    }, e.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var r = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = Wi(r);
      }
    }, e.prototype._minScale = function(t) {
      var r = Math.min(this.scale, t.scale), n = be.combine(this._highLowAtScale(this.positive, this.scale, r), this._highLowAtScale(t.positive, t.scale, r)), i = be.combine(this._highLowAtScale(this.negative, this.scale, r), this._highLowAtScale(t.negative, t.scale, r));
      return Math.min(r - this._changeScale(n.high, n.low), r - this._changeScale(i.high, i.low));
    }, e.prototype._highLowAtScale = function(t, r, n) {
      if (t.length === 0)
        return new be(0, -1);
      var i = r - n;
      return new be(t.indexStart >> i, t.indexEnd >> i);
    }, e.prototype._mergeBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(t, o + u >> a, n.at(u));
    }, e.prototype._diffBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, n.at(u));
      }
      t.trim();
    }, e;
  }()
), Ev = (
  /** @class */
  function() {
    function e(t, r) {
      this._maxSize = t, this._recordMinMax = r, this.kind = Tt.EXPONENTIAL_HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new vv(t, this._maxSize, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      var n = r.clone();
      return n.merge(t), n;
    }, e.prototype.diff = function(t, r) {
      var n = r.clone();
      return n.diff(t), n;
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: Y.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = pv(o, 2), u = a[0], c = a[1], s = c.toPointValue(), f = t.type === T.GAUGE || t.type === T.UP_DOWN_COUNTER || t.type === T.OBSERVABLE_GAUGE || t.type === T.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: f ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, e;
  }()
), gv = _e("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function yv(e) {
  return e.setValue(gv, !0);
}
function mv() {
  return function(e) {
    v.error(Tv(e));
  };
}
function Tv(e) {
  return typeof e == "string" ? e : JSON.stringify(Sv(e));
}
function Sv(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Ov = mv();
function qi(e) {
  try {
    Ov(e);
  } catch (t) {
  }
}
var Av = 6, bv = Math.pow(10, Av);
function jn(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * bv);
  return [r, n];
}
function we(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
var An;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(An || (An = {}));
function wv(e, t) {
  return new Promise(function(r) {
    O.with(yv(O.active()), function() {
      e.export(t, function(n) {
        r(n);
      });
    });
  });
}
var Rv = {
  _export: wv
}, Lv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, $r = (
  /** @class */
  function() {
    function e(t, r, n) {
      r === void 0 && (r = 0), n === void 0 && (n = [0, 0]), this.startTime = t, this._current = r, this.sampleTime = n;
    }
    return e.prototype.record = function(t) {
      this._current = t, this.sampleTime = jn(Date.now());
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Pv = (
  /** @class */
  function() {
    function e() {
      this.kind = Tt.LAST_VALUE;
    }
    return e.prototype.createAccumulation = function(t) {
      return new $r(t);
    }, e.prototype.merge = function(t, r) {
      var n = we(r.sampleTime) >= we(t.sampleTime) ? r : t;
      return new $r(t.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.diff = function(t, r) {
      var n = we(r.sampleTime) >= we(t.sampleTime) ? r : t;
      return new $r(r.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: Y.GAUGE,
        dataPoints: n.map(function(o) {
          var a = Lv(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, e;
  }()
), Nv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Zt = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = r, this._current = n, this.reset = i;
    }
    return e.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Yi = (
  /** @class */
  function() {
    function e(t) {
      this.monotonic = t, this.kind = Tt.SUM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Zt(t, this.monotonic);
    }, e.prototype.merge = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return r.reset ? new Zt(r.startTime, this.monotonic, i, r.reset) : new Zt(t.startTime, this.monotonic, n + i);
    }, e.prototype.diff = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return this.monotonic && n > i ? new Zt(r.startTime, this.monotonic, i, !0) : new Zt(r.startTime, this.monotonic, i - n);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: Y.SUM,
        dataPoints: n.map(function(o) {
          var a = Nv(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, e;
  }()
), bt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), rt = (
  /** @class */
  function() {
    function e() {
    }
    return e.Drop = function() {
      return Ja;
    }, e.Sum = function() {
      return Za;
    }, e.LastValue = function() {
      return Qa;
    }, e.Histogram = function() {
      return ts;
    }, e.ExponentialHistogram = function() {
      return kv;
    }, e.Default = function() {
      return Gv;
    }, e;
  }()
), Iv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new J_(), t;
  }(rt)
), Cv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      switch (r.type) {
        case T.COUNTER:
        case T.OBSERVABLE_COUNTER:
        case T.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new Yi(!0), t.NON_MONOTONIC_INSTANCE = new Yi(!1), t;
  }(rt)
), Mv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Pv(), t;
  }(rt)
), xv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new za([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(rt)
), Dv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t(r, n) {
      n === void 0 && (n = !0);
      var i = e.call(this) || this;
      if (i._recordMinMax = n, r == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      r = r.concat(), r = r.sort(function(u, c) {
        return u - c;
      });
      var o = r.lastIndexOf(-1 / 0), a = r.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = r.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(r) {
      return new za(this._boundaries, this._recordMinMax);
    }, t;
  }(rt)
), Uv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t(r, n) {
      r === void 0 && (r = 160), n === void 0 && (n = !0);
      var i = e.call(this) || this;
      return i._maxSize = r, i._recordMinMax = n, i;
    }
    return t.prototype.createAggregator = function(r) {
      return new Ev(this._maxSize, this._recordMinMax);
    }, t;
  }(rt)
), Bv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(r) {
      switch (r.type) {
        case T.COUNTER:
        case T.UP_DOWN_COUNTER:
        case T.OBSERVABLE_COUNTER:
        case T.OBSERVABLE_UP_DOWN_COUNTER:
          return Za;
        case T.GAUGE:
        case T.OBSERVABLE_GAUGE:
          return Qa;
        case T.HISTOGRAM:
          return r.advice.explicitBucketBoundaries ? new Dv(r.advice.explicitBucketBoundaries) : ts;
      }
      return v.warn("Unable to recognize instrument type: " + r.type), Ja;
    }, t.prototype.createAggregator = function(r) {
      return this._resolve(r).createAggregator(r);
    }, t;
  }(rt)
), Ja = new Iv(), Za = new Cv(), Qa = new Mv(), ts = new xv(), kv = new Uv(), Gv = new Bv(), Hv = function(e) {
  return rt.Default();
}, $v = function(e) {
  return X.CUMULATIVE;
}, jr = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Vr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ki = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, jv = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Vv = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i;
      this._shutdown = !1, this._aggregationSelector = (r = t == null ? void 0 : t.aggregationSelector) !== null && r !== void 0 ? r : Hv, this._aggregationTemporalitySelector = (n = t == null ? void 0 : t.aggregationTemporalitySelector) !== null && n !== void 0 ? n : $v, this._metricProducers = (i = t == null ? void 0 : t.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t == null ? void 0 : t.cardinalitySelector;
    }
    return e.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, e.prototype.onInitialized = function() {
    }, e.prototype.collect = function(t) {
      return jr(this, void 0, void 0, function() {
        var r, n, i, o, a, u;
        return Vr(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(jv([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                })
              ], Ki(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                });
              })), !1))];
            case 1:
              return r = Ki.apply(void 0, [c.sent()]), n = r[0], i = r.slice(1), o = n.errors.concat(Vi(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(Vi(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return jr(this, void 0, void 0, function() {
        return Vr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return r.sent(), [3, 4];
            case 2:
              return [4, le(this.onShutdown(), t.timeoutMillis)];
            case 3:
              r.sent(), r.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return jr(this, void 0, void 0, function() {
        return Vr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, le(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), Fv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Re = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Le = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Xv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zv = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Wv = (
  /** @class */
  function(e) {
    Fv(t, e);
    function t(r) {
      var n, i, o, a, u = e.call(this, {
        aggregationSelector: (n = r.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(r.exporter),
        aggregationTemporalitySelector: (i = r.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(r.exporter),
        metricProducers: r.metricProducers
      }) || this;
      if (r.exportIntervalMillis !== void 0 && r.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportIntervalMillis !== void 0 && r.exportIntervalMillis < r.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = r.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = r.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = r.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return Re(this, void 0, void 0, function() {
        var r;
        return Le(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, le(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), r instanceof Xa ? (v.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (qi(r), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var r, n;
      return Re(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return Le(this, function(f) {
          switch (f.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = f.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = v).error.apply(s, zv(["PeriodicExportingMetricReader: metrics collection errors"], Xv(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              f.label = 2;
            case 2:
              return f.trys.push([2, 4, , 5]), [4, (n = (r = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(r)];
            case 3:
              return f.sent(), [3, 5];
            case 4:
              return u = f.sent(), v.debug("Error while resolving async portion of resource: ", u), qi(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, Rv._export(this._exporter, o)];
            case 6:
              if (c = f.sent(), c.code !== An.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var r = this;
      this._interval = setInterval(function() {
        r._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return Re(this, void 0, void 0, function() {
        return Le(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return r.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return Re(this, void 0, void 0, function() {
        return Le(this, function(r) {
          switch (r.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return r.sent(), [4, this._exporter.shutdown()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(Vv)
), qv = (
  /** @class */
  function() {
    function e() {
      this._registeredViews = [];
    }
    return e.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, e.prototype.findViews = function(t, r) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, t) && n._matchMeter(o.meterSelector, r);
      });
      return i;
    }, e.prototype._matchInstrument = function(t, r) {
      return (t.getType() === void 0 || r.type === t.getType()) && t.getNameFilter().match(r.name) && t.getUnitFilter().match(r.unit);
    }, e.prototype._matchMeter = function(t, r) {
      return t.getNameFilter().match(r.name) && (r.version === void 0 || t.getVersionFilter().match(r.version)) && (r.schemaUrl === void 0 || t.getSchemaUrlFilter().match(r.schemaUrl));
    }, e;
  }()
), wt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), er = (
  /** @class */
  function() {
    function e(t, r) {
      this._writableMetricStorage = t, this._descriptor = r;
    }
    return e.prototype._record = function(t, r, n) {
      if (r === void 0 && (r = {}), n === void 0 && (n = O.active()), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === lt.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, r, n, jn(Date.now()));
    }, e;
  }()
), Yv = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(er)
), Kv = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      if (r < 0) {
        v.warn("negative value provided to counter " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(er)
), Jv = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(er)
), Zv = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      if (r < 0) {
        v.warn("negative value provided to histogram " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(er)
), rr = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._observableRegistry = n, this._descriptor = t, this._metricStorages = r;
    }
    return e.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, e.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, e;
  }()
), Qv = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(rr)
), tE = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(rr)
), eE = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(rr)
);
function bn(e) {
  return e instanceof rr;
}
var rE = (
  /** @class */
  function() {
    function e(t) {
      this._meterSharedState = t;
    }
    return e.prototype.createGauge = function(t, r) {
      var n = ot(t, T.GAUGE, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Jv(i, n);
    }, e.prototype.createHistogram = function(t, r) {
      var n = ot(t, T.HISTOGRAM, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Zv(i, n);
    }, e.prototype.createCounter = function(t, r) {
      var n = ot(t, T.COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Kv(i, n);
    }, e.prototype.createUpDownCounter = function(t, r) {
      var n = ot(t, T.UP_DOWN_COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Yv(i, n);
    }, e.prototype.createObservableGauge = function(t, r) {
      var n = ot(t, T.OBSERVABLE_GAUGE, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new tE(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableCounter = function(t, r) {
      var n = ot(t, T.OBSERVABLE_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Qv(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      var n = ot(t, T.OBSERVABLE_UP_DOWN_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new eE(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.addBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, r);
    }, e.prototype.removeBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, r);
    }, e;
  }()
), es = (
  /** @class */
  function() {
    function e(t) {
      this._instrumentDescriptor = t;
    }
    return e.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, e.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = ot(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, e;
  }()
), nE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ji = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, iE = (
  /** @class */
  function() {
    function e(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.get = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.get(r);
    }, e.prototype.getOrDefault = function(t, r) {
      var n = this._hash(t);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = r();
      return this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, i), i;
    }, e.prototype.set = function(t, r, n) {
      n != null || (n = this._hash(t)), this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, r);
    }, e.prototype.has = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.has(r);
    }, e.prototype.keys = function() {
      var t, r;
      return Ji(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._keyMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e.prototype.entries = function() {
      var t, r;
      return Ji(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._valueMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [this._keyMap.get(r.value[0]), r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), yt = (
  /** @class */
  function(e) {
    nE(t, e);
    function t() {
      return e.call(this, Fa) || this;
    }
    return t;
  }(iE)
), oE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, rs = (
  /** @class */
  function() {
    function e(t, r) {
      this._aggregator = t, this._activeCollectionStorage = new yt(), this._cumulativeMemoStorage = new yt(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (r != null ? r : 2e3) - 1, this._overflowHashCode = Fa(this._overflowAttributes);
    }
    return e.prototype.record = function(t, r, n, i) {
      var o = this, a = this._activeCollectionStorage.get(r);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(r, a);
      }
      a == null || a.record(t);
    }, e.prototype.batchCumulate = function(t, r) {
      var n = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = oE(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(r);
        s == null || s.record(u);
        var f = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var l = n._cumulativeMemoStorage.get(a, c);
          f = n._aggregator.diff(l, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var l = n._cumulativeMemoStorage.get(a, c);
          f = n._aggregator.diff(l, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var d = n._activeCollectionStorage.get(a, c);
          f = n._aggregator.merge(d, f);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, f, c);
      });
    }, e.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new yt(), t;
    }, e;
  }()
), Fr = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Zi = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ns = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), r.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return e.prototype.buildMetrics = function(t, r, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === X.CUMULATIVE ? a = e.merge(c.accumulations, o, this._aggregator) : a = e.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(r.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var f = aE(a);
      if (f.length !== 0)
        return this._aggregator.toMetricData(
          r,
          u,
          f,
          /* endTime */
          i
        );
    }, e.prototype._stashAccumulations = function(t) {
      var r, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = Fr(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype._getMergedUnreportedAccumulations = function(t) {
      var r, n, i = new yt(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = Fr(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = e.merge(i, c, this._aggregator);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e.merge = function(t, r, n) {
      for (var i = t, o = r.entries(), a = o.next(); a.done !== !0; ) {
        var u = Zi(a.value, 3), c = u[0], s = u[1], f = u[2];
        if (t.has(c, f)) {
          var l = t.get(c, f), d = n.merge(l, s);
          i.set(c, d, f);
        } else
          i.set(c, s, f);
        a = o.next();
      }
      return i;
    }, e.calibrateStartTime = function(t, r, n) {
      var i, o;
      try {
        for (var a = Fr(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = Zi(u.value, 2), s = c[0], f = c[1], l = r.get(s, f);
          l == null || l.setStartTime(n);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return r;
    }, e;
  }()
);
function aE(e) {
  return Array.from(e.entries());
}
var sE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), uE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, cE = (
  /** @class */
  function(e) {
    sE(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new rs(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ns(n, o), u;
    }
    return t.prototype.record = function(r, n) {
      var i = this, o = new yt();
      Array.from(r.entries()).forEach(function(a) {
        var u = uE(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(es)
);
function Qi(e, t) {
  var r = "";
  return e.unit !== t.unit && (r += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (r += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (r += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (r += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), r;
}
function fE(e, t) {
  return "	- use valueType '" + e.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function lE(e, t) {
  return "	- use unit '" + e.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function dE(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + "'";
}
function pE(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + e.name + " and description '" + e.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + t.name + " and description '" + e.description + "' and InstrumentSelector " + n;
}
function to(e, t) {
  return e.valueType !== t.valueType ? fE(e, t) : e.unit !== t.unit ? lE(e, t) : e.type !== t.type ? dE(e, t) : e.description !== t.description ? pE(e, t) : "";
}
var Xr = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, hE = (
  /** @class */
  function() {
    function e() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return e.create = function() {
      return new e();
    }, e.prototype.getStorages = function(t) {
      var r, n, i, o, a = [];
      try {
        for (var u = Xr(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (h) {
        r = { error: h };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var f = this._perCollectorRegistry.get(t);
      if (f != null)
        try {
          for (var l = Xr(f.values()), d = l.next(); !d.done; d = l.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            d && !d.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, e.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, e.prototype.registerForCollector = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, n)), this._registerStorage(r, n);
    }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
      var r = this._sharedRegistry.get(t.name);
      return r === void 0 ? null : this._findOrUpdateCompatibleStorage(t, r);
    }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      if (n === void 0)
        return null;
      var i = n.get(r.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(r, i);
    }, e.prototype._registerStorage = function(t, r) {
      var n = t.getInstrumentDescriptor(), i = r.get(n.name);
      if (i === void 0) {
        r.set(n.name, [t]);
        return;
      }
      i.push(t);
    }, e.prototype._findOrUpdateCompatibleStorage = function(t, r) {
      var n, i, o = null;
      try {
        for (var a = Xr(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          Q_(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), v.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, Qi(s, t), `The longer description will be used.
To resolve the conflict:`, to(s, t))), o = c) : v.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, Qi(s, t), `To resolve the conflict:
`, to(s, t));
        }
      } catch (f) {
        n = { error: f };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, e;
  }()
), _E = (
  /** @class */
  function() {
    function e(t) {
      this._backingStorages = t;
    }
    return e.prototype.record = function(t, r, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, r, n, i);
      });
    }, e;
  }()
), vE = (
  /** @class */
  function() {
    function e(t, r) {
      this._instrumentName = t, this._valueType = r, this._buffer = new yt();
    }
    return e.prototype.observe = function(t, r) {
      if (r === void 0 && (r = {}), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === lt.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(r, t);
    }, e;
  }()
), EE = (
  /** @class */
  function() {
    function e() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return e.prototype.observe = function(t, r, n) {
      if (n === void 0 && (n = {}), !!bn(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new yt(), this._buffer.set(t, i)), typeof r != "number") {
          v.warn("non-number value provided to metric " + t._descriptor.name + ": " + r);
          return;
        }
        t._descriptor.valueType === lt.INT && !Number.isInteger(r) && (v.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), r = Math.trunc(r), !Number.isInteger(r)) || i.set(n, r);
      }
    }, e;
  }()
), zr = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Wr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, eo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ro = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, gE = (
  /** @class */
  function() {
    function e() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return e.prototype.addCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n >= 0 || this._callbacks.push({ callback: t, instrument: r });
    }, e.prototype.removeCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n < 0 || this._callbacks.splice(n, 1);
    }, e.prototype.addBatchCallback = function(t, r) {
      var n = new Set(r.filter(bn));
      if (n.size === 0) {
        v.error("BatchObservableCallback is not associated with valid instruments", r);
        return;
      }
      var i = this._findBatchCallback(t, n);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: n });
    }, e.prototype.removeBatchCallback = function(t, r) {
      var n = new Set(r.filter(bn)), i = this._findBatchCallback(t, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, e.prototype.observe = function(t, r) {
      return zr(this, void 0, void 0, function() {
        var n, i, o, a;
        return Wr(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(t, r), i = this._observeBatchCallbacks(t, r), [4, z_(ro(ro([], eo(n), !1), eo(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(W_).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, e.prototype._observeCallbacks = function(t, r) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return zr(n, void 0, void 0, function() {
          var u, c;
          return Wr(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new vE(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), r != null && (c = le(c, r)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(f) {
                  f.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._observeBatchCallbacks = function(t, r) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return zr(n, void 0, void 0, function() {
          var u, c;
          return Wr(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new EE(), c = Promise.resolve(o(u)), r != null && (c = le(c, r)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(f) {
                  var l = u._buffer.get(f);
                  l != null && f._metricStorages.forEach(function(d) {
                    d.record(l, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._findCallback = function(t, r) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === t && n.instrument === r;
      });
    }, e.prototype._findBatchCallback = function(t, r) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === t && q_(n.instruments, r);
      });
    }, e;
  }()
), yE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), mE = (
  /** @class */
  function(e) {
    yE(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new rs(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ns(n, o), u;
    }
    return t.prototype.record = function(r, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(r, n, i, o);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(es)
), is = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Vn = (
  /** @class */
  function() {
    function e() {
    }
    return e.Noop = function() {
      return SE;
    }, e;
  }()
), TE = (
  /** @class */
  function(e) {
    is(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.process = function(r, n) {
      return r;
    }, t;
  }(Vn)
);
(function(e) {
  is(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n._allowedAttributeNames = r, n;
  }
  return t.prototype.process = function(r, n) {
    var i = this, o = {};
    return Object.keys(r).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = r[a];
    }), o;
  }, t;
})(Vn);
var SE = new TE(), OE = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, AE = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, bE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, wE = (
  /** @class */
  function() {
    function e(t, r) {
      this._meterProviderSharedState = t, this._instrumentationScope = r, this.metricStorageRegistry = new hE(), this.observableRegistry = new gE(), this.meter = new rE(this);
    }
    return e.prototype.registerMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, mE);
      return r.length === 1 ? r[0] : new _E(r);
    }, e.prototype.registerAsyncMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, cE);
      return r;
    }, e.prototype.collect = function(t, r, n) {
      return OE(this, void 0, void 0, function() {
        var i, o, a;
        return AE(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(r, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, r);
              }).filter(F_), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, e.prototype._registerMetricStorage = function(t, r) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = Z_(c, t), f = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (f != null)
          return f;
        var l = c.aggregation.createAggregator(s), d = new r(s, l, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = bE(c, 2), f = s[0], l = s[1], d = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(f, t);
          if (d != null)
            return d;
          var h = l.createAggregator(t), _ = f.selectCardinalityLimit(t.type), p = new r(t, h, Vn.Noop(), [f], _);
          return n.metricStorageRegistry.registerForCollector(f, p), p;
        });
        o = o.concat(u);
      }
      return o;
    }, e;
  }()
), RE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, LE = (
  /** @class */
  function() {
    function e(t) {
      this.resource = t, this.viewRegistry = new qv(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return e.prototype.getMeterSharedState = function(t) {
      var r = X_(t), n = this.meterSharedStates.get(r);
      return n == null && (n = new wE(this, t), this.meterSharedStates.set(r, n)), n;
    }, e.prototype.selectAggregations = function(t) {
      var r, n, i = [];
      try {
        for (var o = RE(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e;
  }()
), Pe = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ne = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, PE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, NE = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, IE = (
  /** @class */
  function() {
    function e(t, r) {
      this._sharedState = t, this._metricReader = r;
    }
    return e.prototype.collect = function(t) {
      return Pe(this, void 0, void 0, function() {
        var r, n, i, o, a = this;
        return Ne(this, function(u) {
          switch (u.label) {
            case 0:
              return r = jn(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return Pe(a, void 0, void 0, function() {
                  var s;
                  return Ne(this, function(f) {
                    switch (f.label) {
                      case 0:
                        return [4, c.collect(this, r, t)];
                      case 1:
                        return s = f.sent(), (s == null ? void 0 : s.scopeMetrics) != null && n.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, NE([], PE(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Pe(this, void 0, void 0, function() {
        return Ne(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return Pe(this, void 0, void 0, function() {
        return Ne(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, e.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      var r, n, i;
      return (i = (n = (r = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(r, t)) !== null && i !== void 0 ? i : 2e3;
    }, e;
  }()
), no = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, io = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, oo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function CE(e, t) {
  var r = t != null ? t : ce.empty();
  return e ? ce.default().merge(r) : r;
}
var ME = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new LE(CE((a = t == null ? void 0 : t.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t == null ? void 0 : t.resource)), (t == null ? void 0 : t.views) != null && t.views.length > 0)
        try {
          for (var u = oo(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      if ((t == null ? void 0 : t.readers) != null && t.readers.length > 0)
        try {
          for (var f = oo(t.readers), l = f.next(); !l.done; l = f.next()) {
            var d = l.value;
            this.addMetricReader(d);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            l && !l.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return e.prototype.getMeter = function(t, r, n) {
      return r === void 0 && (r = ""), n === void 0 && (n = {}), this._shutdown ? (v.warn("A shutdown MeterProvider cannot provide a Meter"), nc()) : this._sharedState.getMeterSharedState({
        name: t,
        version: r,
        schemaUrl: n.schemaUrl
      }).meter;
    }, e.prototype.addMetricReader = function(t) {
      var r = new IE(this._sharedState, t);
      t.setMetricProducer(r), this._sharedState.metricCollectors.push(r);
    }, e.prototype.shutdown = function(t) {
      return no(this, void 0, void 0, function() {
        return io(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(t);
              }))]);
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return no(this, void 0, void 0, function() {
        return io(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(t);
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function xE(e, t) {
  var r = Ga(t);
  return {
    resource: Ha(e.resource),
    schemaUrl: void 0,
    scopeMetrics: DE(e.scopeMetrics, r)
  };
}
function DE(e, t) {
  return Array.from(e.map(function(r) {
    return {
      scope: $a(r.scope),
      metrics: r.metrics.map(function(n) {
        return UE(n, t);
      }),
      schemaUrl: r.scope.schemaUrl
    };
  }));
}
function UE(e, t) {
  var r = {
    name: e.descriptor.name,
    description: e.descriptor.description,
    unit: e.descriptor.unit
  }, n = HE(e.aggregationTemporality);
  switch (e.dataPointType) {
    case Y.SUM:
      r.sum = {
        aggregationTemporality: n,
        isMonotonic: e.isMonotonic,
        dataPoints: ao(e, t)
      };
      break;
    case Y.GAUGE:
      r.gauge = {
        dataPoints: ao(e, t)
      };
      break;
    case Y.HISTOGRAM:
      r.histogram = {
        aggregationTemporality: n,
        dataPoints: kE(e, t)
      };
      break;
    case Y.EXPONENTIAL_HISTOGRAM:
      r.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: GE(e, t)
      };
      break;
  }
  return r;
}
function BE(e, t, r) {
  var n = {
    attributes: At(e.attributes),
    startTimeUnixNano: r.encodeHrTime(e.startTime),
    timeUnixNano: r.encodeHrTime(e.endTime)
  };
  switch (t) {
    case lt.INT:
      n.asInt = e.value;
      break;
    case lt.DOUBLE:
      n.asDouble = e.value;
      break;
  }
  return n;
}
function ao(e, t) {
  return e.dataPoints.map(function(r) {
    return BE(r, e.descriptor.valueType, t);
  });
}
function kE(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: At(r.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function GE(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: At(r.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function HE(e) {
  switch (e) {
    case X.DELTA:
      return 1;
    case X.CUMULATIVE:
      return 2;
  }
}
function $E(e, t) {
  return {
    resourceMetrics: e.map(function(r) {
      return xE(r, t);
    })
  };
}
var jE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, VE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function FE(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: At(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return zE(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return XE(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function XE(e, t) {
  var r;
  return {
    attributes: e.attributes ? At(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function zE(e, t) {
  return {
    attributes: e.attributes ? At(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function WE(e, t) {
  var r = Ga(t);
  return {
    resourceSpans: YE(e, r)
  };
}
function qE(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = jE(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (f) {
    t = { error: f };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function YE(e, t) {
  for (var r = qE(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = VE(o.value, 2), u = a[0], c = a[1], s = [], f = c.values(), l = f.next(); !l.done; ) {
      var d = l.value;
      if (d.length > 0) {
        var h = d.map(function(p) {
          return FE(p, t);
        });
        s.push({
          scope: $a(d[0].instrumentationLibrary),
          spans: h,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      l = f.next();
    }
    var _ = {
      resource: Ha(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(_), o = i.next();
  }
  return n;
}
var KE = {
  serializeRequest: function(e) {
    var t = $E([e], {
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, JE = {
  serializeRequest: function(e) {
    var t = WE(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, ZE = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, QE = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, tg = 5, eg = 1e3, rg = 5e3, ng = 1.5, so = 0.2;
function ig() {
  return Math.random() * (2 * so) - so;
}
var og = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, r).then(o, a);
        }, n);
      });
    }, e.prototype.send = function(t, r) {
      var n;
      return ZE(this, void 0, void 0, function() {
        var i, o, a, u, c, s, f;
        return QE(this, function(l) {
          switch (l.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              o = l.sent(), a = tg, u = eg, l.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, rg) + ig(), 0), u = u * ng, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, f = i - Date.now(), s > f ? [2, o] : [4, this.retry(t, f, s)]) : [3, 4];
            case 3:
              return o = l.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function os(e) {
  return new og(e.transport);
}
function ag(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function sg(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var r = new Date(e).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var ug = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, cg = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = ug(u, 2), s = c[0], f = c[1];
          o.setRequestHeader(s, f);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (v.debug("XHR success"), i({
            status: "success"
          })) : o.status && ag(o.status) ? i({
            status: "retryable",
            retryInMillis: sg(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function fg(e) {
  return new cg(e);
}
var lg = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (v.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function dg(e) {
  return new lg(e);
}
function pg(e, t) {
  return Da(e, t, os({
    transport: fg(e)
  }));
}
function hg(e, t) {
  return Da(e, t, os({
    transport: dg({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var _g = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function vg(e) {
  return function() {
    var t, r = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(n) {
      var i = _g(n, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? r[o] = String(a) : v.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), r;
  };
}
var St = function() {
  return St = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, St.apply(this, arguments);
};
function Eg(e, t, r) {
  var n = St({}, r()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, n);
  };
}
function gg(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch (t) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function yg(e, t, r) {
  var n, i, o, a;
  return St(St({}, m_(e, t, r)), { headers: Eg(vg(e.headers), t.headers, r.headers), url: (i = (n = gg(e.url)) !== null && n !== void 0 ? n : t.url) !== null && i !== void 0 ? i : r.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : r.agentOptions });
}
function mg(e, t) {
  return St(St({}, T_()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function Tg(e, t, r) {
  return yg(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: y_(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    mg(r, t)
  );
}
function as(e, t, r, n) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = Tg(e, r, n);
  return i ? pg(o, t) : hg(o, t);
}
var Sg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Og = (
  /** @class */
  function(e) {
    Sg(t, e);
    function t(r) {
      return r === void 0 && (r = {}), e.call(this, as(r, JE, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(xa)
), qe;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(qe || (qe = {}));
var Ag = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), wn = function() {
  return X.CUMULATIVE;
}, ss = function(e) {
  switch (e) {
    case T.COUNTER:
    case T.OBSERVABLE_COUNTER:
    case T.GAUGE:
    case T.HISTOGRAM:
    case T.OBSERVABLE_GAUGE:
      return X.DELTA;
    case T.UP_DOWN_COUNTER:
    case T.OBSERVABLE_UP_DOWN_COUNTER:
      return X.CUMULATIVE;
  }
}, us = function(e) {
  switch (e) {
    case T.COUNTER:
    case T.HISTOGRAM:
      return X.DELTA;
    case T.GAUGE:
    case T.UP_DOWN_COUNTER:
    case T.OBSERVABLE_UP_DOWN_COUNTER:
    case T.OBSERVABLE_COUNTER:
    case T.OBSERVABLE_GAUGE:
      return X.CUMULATIVE;
  }
};
function bg() {
  var e = sf(), t = e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? wn : t === "delta" ? ss : t === "lowmemory" ? us : (v.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), wn);
}
function wg(e) {
  return e != null ? e === qe.DELTA ? ss : e === qe.LOWMEMORY ? us : wn : bg();
}
function Rg(e) {
  return e != null && e.aggregationPreference ? e.aggregationPreference : function(t) {
    return rt.Default();
  };
}
var Lg = (
  /** @class */
  function(e) {
    Ag(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i._aggregationSelector = Rg(n), i._aggregationTemporalitySelector = wg(n == null ? void 0 : n.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(r) {
      return this._aggregationSelector(r);
    }, t.prototype.selectAggregationTemporality = function(r) {
      return this._aggregationTemporalitySelector(r);
    }, t;
  }(xa)
), Pg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ng = (
  /** @class */
  function(e) {
    Pg(t, e);
    function t(r) {
      return e.call(this, as(r != null ? r : {}, KE, "v1/metrics", { "Content-Type": "application/json" }), r) || this;
    }
    return t;
  }(Lg)
);
function Ig(e, t) {
  const r = e.spanContext();
  return {
    name: e.name,
    kind: e.kind,
    spanContext: () => r,
    parentSpanId: e.parentSpanId,
    startTime: e.startTime,
    endTime: e.endTime,
    status: e.status,
    attributes: Xf(e.attributes, t),
    links: e.links,
    events: e.events,
    duration: e.duration,
    ended: e.ended,
    resource: e.resource,
    instrumentationLibrary: e.instrumentationLibrary,
    droppedAttributesCount: e.droppedAttributesCount,
    droppedEventsCount: e.droppedEventsCount,
    droppedLinksCount: e.droppedLinksCount
  };
}
function Cg(e, t) {
  if (!t.isSamplingEnabled())
    return e;
  const r = [], n = {}, i = {};
  for (const o of e) {
    o.parentSpanId && (i[o.parentSpanId] = i[o.parentSpanId] || [], i[o.parentSpanId].push(
      o.spanContext().spanId
    ));
    const a = t.shouldSample(o);
    a.sample ? a.attributes ? n[o.spanContext().spanId] = Ig(
      o,
      a.attributes
    ) : n[o.spanContext().spanId] = o : r.push(o.spanContext().spanId);
  }
  for (; r.length > 0; ) {
    const o = r.shift(), a = i[o];
    if (a)
      for (const u of a)
        delete n[u], r.push(u);
  }
  return Object.values(n);
}
class Mg extends Og {
  constructor(t, r) {
    super(P(S({}, t), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    })), this.sampler = r;
  }
  export(t, r) {
    const n = Cg(t, this.sampler);
    if (n.length === 0)
      return;
    let i = 0;
    const o = (a) => {
      if (a.code === x.SUCCESS)
        return r({
          code: x.SUCCESS
        });
      if (i++, i > Po)
        return r({
          code: x.FAILED,
          error: a.error
        });
      new Promise(
        (u) => setTimeout(
          u,
          No + Io * Math.pow(2, i)
        )
      ).then(() => {
        super.export(n, o);
      });
    };
    super.export(n, o);
  }
}
class xg extends Ng {
  constructor(t) {
    super(P(S({}, t), {
      headers: {}
    }));
  }
  export(t, r) {
    let n = 0;
    const i = (o) => {
      var a;
      if (o.code === x.SUCCESS)
        return r({
          code: x.SUCCESS
        });
      if (n++, n > Po)
        return console.error(
          `[@launchdarkly/observability] failed to export OTeL metrics: ${(a = o.error) == null ? void 0 : a.message}`,
          o.error
        ), r({
          code: x.FAILED,
          error: o.error
        });
      new Promise(
        (u) => setTimeout(
          u,
          No + Io * Math.pow(2, n)
        )
      ).then(() => {
        var u;
        console.warn(
          `[@launchdarkly/observability] retry ${n}, failed to export OTeL metrics: ${(u = o.error) == null ? void 0 : u.message}`,
          o.error
        ), super.export(t, i);
      });
    };
    super.export(t, i);
  }
}
const Dg = "OT_ZONE_CONTEXT", Ug = "Navigation:", Bg = ["click", "input", "submit"];
function kg() {
  return !1;
}
const z = class z extends al {
  constructor(r = {}) {
    var n;
    super(
      z.moduleName,
      z.version,
      r
    );
    R(this, "_spansData", /* @__PURE__ */ new WeakMap());
    R(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    R(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    R(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    R(this, "_eventNames");
    R(this, "_shouldPreventSpanCreation");
    this._eventNames = new Set(
      (n = r == null ? void 0 : r.eventNames) != null ? n : Bg
    ), this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : kg;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(r, n) {
    const i = this._spansData.get(n);
    i && (r.source === "setTimeout" ? i.hrTimeLastTimeout = df() : r.source !== "Promise.then" && r.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return this._eventNames.has(r);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var u;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = ba(i, !0);
    try {
      const c = this.tracer.startSpan(
        o,
        {
          attributes: {
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.classname": i.className,
            "event.text": (u = i.textContent) != null ? u : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        n ? A.setSpan(O.active(), n) : void 0
      );
      return r instanceof MouseEvent && (c.setAttribute("event.x", r.clientX), c.setAttribute("event.y", r.clientY), c.setAttribute(
        "event.relativeX",
        r.clientX / window.innerWidth
      ), c.setAttribute(
        "event.relativeY",
        r.clientY / window.innerHeight
      ), o === "scroll" && (c.setAttribute("event.scrollX", window.scrollX), c.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(o, i, c) === !0 ? void 0 : (this._spansData.set(c, {
        taskCount: 0
      }), c);
    } catch (c) {
      this._diag.error(
        "failed to start create new user interaction span",
        c
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(r) {
    const n = this._spansData.get(r);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(r, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(r) {
    const n = r.get(Dg);
    return n && A.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(r) {
    const n = this._spansData.get(r);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(n);
    return u || (u = /* @__PURE__ */ new Map(), a.set(n, u)), u.has(r) ? !1 : (u.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const u = a.get(r);
    return u && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const r = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, f = function(...l) {
        var p;
        let d;
        const h = l[0];
        if (!(h != null && h.type))
          return r._invokeListener(u, this, l);
        if (Date.now() - ((p = n.get(h.type)) != null ? p : 0) < 1e3 / 60)
          return r._invokeListener(u, this, l);
        n.set(h.type, Date.now()), h && (d = r._eventsSpanMap.get(h)), s && r.removePatchedListener(this, a, u);
        const _ = r._createSpan(h, d);
        return _ ? (h && r._eventsSpanMap.set(h, _), O.with(
          A.setSpan(O.active(), _),
          () => {
            const E = r._invokeListener(
              u,
              this,
              l
            );
            return _.end(), E;
          }
        )) : r._invokeListener(u, this, l);
      };
      if (r.addPatchedListener(
        this,
        a,
        u,
        f
      ))
        return i.call(
          this,
          a,
          f,
          c
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = r.removePatchedListener(
        this,
        o,
        a
      );
      return c ? n.call(
        this,
        o,
        c,
        u
      ) : n.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const r = this;
    return (n) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = n.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && r._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    M(history.replaceState) && this._unwrap(history, "replaceState"), M(history.pushState) && this._unwrap(history, "pushState"), M(history.back) && this._unwrap(history, "back"), M(history.forward) && this._unwrap(history, "forward"), M(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(r) {
    const n = A.getSpan(
      O.active()
    );
    n && typeof n.updateName == "function" && n.updateName(`${Ug} ${r}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && r._decrementTask(u), n.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && (r._incrementTask(u), r._checkForTimeout(o, u)), n.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let f;
      const l = this;
      if (s) {
        if (f = r._createSpan(c), f)
          return r._incrementTask(f), l.run(() => {
            try {
              return O.with(
                A.setSpan(
                  O.active(),
                  f
                ),
                () => {
                  const d = Zone.current;
                  return o._zone = d, n.call(
                    d,
                    o,
                    a,
                    u
                  );
                }
              );
            } finally {
              r._decrementTask(f);
            }
          });
      } else
        f = r._getCurrentSpan(l);
      try {
        return n.call(l, o, a, u);
      } finally {
        f && r._shouldCountTask(o, l) && r._decrementTask(f);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(r, n) {
    if (r._zone && (n = r._zone), !n || !r.data || r.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : r.type === "macroTask" || r.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(r, n) {
    r && this._spansData.get(r) && (r.end(n), this._spansData.delete(r));
  }
  /**
   * implements enable function
   */
  enable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      z.moduleName,
      z.version,
      "zone:",
      !!r
    ), r ? (M(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), M(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), M(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      r.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      r.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      r.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      M(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), M(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        i,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        i,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      z.moduleName,
      z.version,
      "zone:",
      !!r
    ), r && this._zonePatched ? (M(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), M(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), M(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      M(i.addEventListener) && this._unwrap(i, "addEventListener"), M(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
R(z, "version", "0.1.1"), R(z, "moduleName", "user-interaction");
let Rn = z, I = {}, Z;
const Ye = "highlight.record", Gg = "highlight.session_id", cs = "launchdarkly.js.log", Hg = "launchdarkly.exception.id", uo = "launchdarkly.sampling.ratio", fs = "log.severity", ls = "log.message", $g = (e, t) => {
  var p, E, g, y, b, L, G, B, Lt;
  if (I.tracerProvider || I.meterProvider) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  Z = e;
  const r = e.backendUrl || void 0 || "https://pub.highlight.io", n = [
    ...(E = (p = e.networkRecordingOptions) == null ? void 0 : p.urlBlocklist) != null ? E : [],
    ...i_
  ], i = (g = e.environment) != null ? g : "production", o = {
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 10,
    timeoutMillis: 3e4,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 6e4,
      keepAlive: !0
    }
  }, a = new Mg(
    o,
    t
  ), u = new jg(a, {
    maxExportBatchSize: 1024,
    // Default value from SDK is 512
    maxQueueSize: 2048,
    // Default value from SDK is 2048
    exportTimeoutMillis: o.timeoutMillis,
    // Default value from SDK is 30_000
    scheduledDelayMillis: o.timeoutMillis
    // Default value from SDK is 1000
  }), c = new ce({
    [xs]: (y = e.serviceName) != null ? y : "highlight-browser",
    [Ms]: e.serviceVersion,
    "deployment.environment.name": i,
    "highlight.project_id": e.projectId,
    [Cs]: navigator.userAgent,
    "browser.language": navigator.language,
    "telemetry.distro.name": "@highlight-run/observability",
    "telemetry.distro.version": Is
  });
  I.tracerProvider = new vp({
    resource: c,
    mergeResourceWithDefaults: !0,
    spanProcessors: [u]
  }), A.setGlobalTracerProvider(I.tracerProvider);
  const s = new xg(P(S({}, o), {
    url: e.otlpEndpoint + "/v1/metrics"
  })), f = new Wv({
    exporter: s,
    exportIntervalMillis: o.timeoutMillis,
    exportTimeoutMillis: o.timeoutMillis
  });
  I.meterProvider = new ME({ resource: c, readers: [f] }), $t.setGlobalMeterProvider(I.meterProvider);
  let l = [];
  ((b = e.instrumentations) == null ? void 0 : b["@opentelemetry/instrumentation-document-load"]) !== !1 && l.push(
    new xp({
      applyCustomAttributesOnSpan: {
        documentLoad: po,
        documentFetch: po,
        resourceFetch: Jg
      }
    })
  ), ((L = e.instrumentations) == null ? void 0 : L["@opentelemetry/instrumentation-user-interaction"]) !== !1 && l.push(
    new Rn({
      eventNames: e.eventNames
    })
  ), (G = e.networkRecordingOptions) != null && G.enabled && (((B = e.instrumentations) == null ? void 0 : B["@opentelemetry/instrumentation-fetch"]) !== !1 && l.push(
    new Th({
      propagateTraceHeaderCorsUrls: ho(
        e.tracingOrigins
      ),
      applyCustomAttributesOnSpan: (H, nt, it) => k(void 0, null, function* () {
        var Ft, Xt, zt;
        if (!(!H.attributes || H.attributes[Ye] === !1)) {
          if (fo(
            H,
            nt.body,
            nt.headers,
            e.networkRecordingOptions
          ), !(it instanceof Response)) {
            H.setAttributes({
              "http.response.error": it.message,
              [Ns]: it.status
            });
            return;
          }
          if ((Ft = e.networkRecordingOptions) != null && Ft.recordHeadersAndBody) {
            const me = yield Ma(
              it,
              (Xt = e.networkRecordingOptions) == null ? void 0 : Xt.bodyKeysToRecord,
              (zt = e.networkRecordingOptions) == null ? void 0 : zt.networkBodyKeysToRedact
            ), or = Object.fromEntries(
              it.headers.entries()
            );
            lo(
              H,
              or,
              me,
              e.networkRecordingOptions
            );
          }
        }
      })
    })
  ), ((Lt = e.instrumentations) == null ? void 0 : Lt["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && l.push(
    new r_({
      propagateTraceHeaderCorsUrls: ho(
        e.tracingOrigins
      ),
      applyCustomAttributesOnSpan: (H, nt) => {
        var Ft, Xt, zt;
        const it = nt;
        if (!(!H.attributes || H.attributes[Ye] === !1) && (fo(
          H,
          it._body,
          it._requestHeaders,
          e.networkRecordingOptions
        ), (Ft = e.networkRecordingOptions) != null && Ft.recordHeadersAndBody)) {
          let me = "";
          (nt.responseType === "" || nt.responseType === "text") && (me = et(
            nt.responseText,
            (Xt = e.networkRecordingOptions) == null ? void 0 : Xt.networkBodyKeysToRedact,
            (zt = e.networkRecordingOptions) == null ? void 0 : zt.bodyKeysToRecord,
            void 0
          ));
          const or = Wg(
            nt.getAllResponseHeaders()
          );
          lo(
            H,
            or,
            me,
            e.networkRecordingOptions
          );
        }
      }
    })
  )), el({ instrumentations: l });
  const _ = new Sa();
  return _.enable(), I.tracerProvider.register({
    contextManager: _,
    propagator: new _f({
      propagators: [
        new Vc(),
        new Vg({
          backendUrl: r,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: n
        })
      ]
    })
  }), I;
};
class jg extends Ta {
  onStart(t, r) {
    t.setAttribute(Gg, at()), super.onStart(t, r);
  }
  onEnd(t) {
    t.attributes[Ye] !== !1 && super.onEnd(t);
  }
}
class Vg extends Cf {
  constructor(r) {
    super();
    R(this, "highlightEndpoints");
    R(this, "tracingOrigins");
    R(this, "urlBlocklist");
    this.highlightEndpoints = [
      r.backendUrl,
      `${r.otlpEndpoint}/v1/traces`,
      `${r.otlpEndpoint}/v1/logs`,
      `${r.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    var u;
    const o = A.getSpan(r);
    if (!o || !o.attributes)
      return;
    const a = _s(o);
    typeof a == "string" && (Kg(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(Ye, !1), !Gn(
      a,
      (u = this.tracingOrigins) != null ? u : [],
      this.urlBlocklist
    )) || super.inject(r, n, i);
  }
}
const ds = "highlight-browser", Fg = ds, co = () => {
  var e;
  return (e = I.tracerProvider) == null ? void 0 : e.getTracer(ds);
}, Ie = () => {
  var e;
  return (e = I.meterProvider) == null ? void 0 : e.getMeter(Fg);
}, Xg = () => A.getActiveSpan(), zg = () => k(void 0, null, function* () {
  yield Promise.allSettled([
    k(void 0, null, function* () {
      I.tracerProvider ? (yield I.tracerProvider.shutdown(), I.tracerProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized tracerProvider."
      );
    }),
    k(void 0, null, function* () {
      I.meterProvider ? (yield I.meterProvider.shutdown(), I.meterProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized meterProvider."
      );
    })
  ]);
}), fo = (e, t, r, n) => {
  var f;
  if (!e.attributes)
    return;
  const o = _s(e), a = Pa(o), u = La(a), c = typeof t == "string" ? t : String(t);
  try {
    const l = t ? JSON.parse(c) : void 0;
    l != null && l.operationName && e.setAttribute(
      "graphql.operation.name",
      l.operationName
    );
  } catch (l) {
  }
  e.setAttributes({
    "highlight.type": "http.request",
    [ne]: a,
    // overwrite with sanitized version
    [ke]: a,
    [Co]: u.pathname,
    [Us]: u.search
  });
  const s = Array.from(
    u.searchParams.entries()
  );
  if (s.length > 0 && e.setAttribute(
    "url.query_params",
    JSON.stringify(Object.fromEntries(s))
  ), n != null && n.recordHeadersAndBody) {
    const l = et(
      t,
      n.networkBodyKeysToRedact,
      n.bodyKeysToRecord,
      r
    );
    e.setAttribute("http.request.body", l);
    const d = Bn(
      (f = n.networkHeadersToRedact) != null ? f : [],
      r,
      n.headerKeysToRecord
    ), h = ps(
      d,
      "http.request.header"
    );
    e.setAttributes(h);
  }
}, Wg = (e) => {
  const t = {};
  return e && e.trim().split(/[\r\n]+/).forEach((r) => {
    const n = r.split(": "), i = n.shift();
    i && (t[i] = n.join(": "));
  }), t;
}, ps = (e, t) => {
  const r = {};
  return Object.entries(e).forEach(([n, i]) => {
    const o = n.toLowerCase().replace(/_/g, "-"), a = `${t}.${o}`, u = Yg(o, i);
    if (r[a]) {
      const c = r[a];
      Array.isArray(c) ? r[a] = [...c, ...u] : r[a] = [c, ...u];
    } else
      r[a] = u.length === 1 ? u[0] : u;
  }), r;
}, qg = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "accept-encoding",
  "accept-language",
  "accept-ranges",
  "allow",
  "cache-control",
  "connection",
  "content-encoding",
  "content-language",
  "expect",
  "if-match",
  "if-none-match",
  "pragma",
  "proxy-authenticate",
  "te",
  "trailer",
  "transfer-encoding",
  "upgrade",
  "vary",
  "via",
  "warning",
  "www-authenticate",
  "access-control-allow-headers",
  "access-control-allow-methods",
  "access-control-expose-headers",
  "access-control-request-headers"
]), Yg = (e, t) => qg.has(e) ? t.split(",").map((r) => r.trim()).filter((r) => r.length > 0) : [t], lo = (e, t, r, n) => {
  var a;
  e.setAttribute("http.response.body", r);
  const i = Bn(
    (a = n.networkHeadersToRedact) != null ? a : [],
    t,
    n.headerKeysToRecord
  ), o = ps(
    i,
    "http.response.header"
  );
  e.setAttributes(o);
}, Kg = (e, t, r, n) => n != null && n.some(
  (o) => e.toLowerCase().includes(o)
) ? !1 : kn(
  e,
  t
), po = (e) => {
  var o, a, u;
  if (!e.events)
    return;
  const r = e.events, n = {
    unload: $("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: $(
      "fetchStart",
      "domInteractive",
      r
    ),
    dom_content_loaded: $(
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      r
    ),
    dom_complete: $("fetchStart", "domComplete", r),
    load_event: $("loadEventStart", "loadEventEnd", r),
    document_load: $("fetchStart", "loadEventEnd", r),
    first_paint: $("fetchStart", "firstPaint", r),
    first_contentful_paint: $(
      "fetchStart",
      "firstContentfulPaint",
      r
    ),
    domain_lookup: $(
      "domainLookupStart",
      "domainLookupEnd",
      r
    ),
    connect: $("connectStart", "connectEnd", r),
    request: $("requestStart", "requestEnd", r),
    response: $("responseStart", "responseEnd", r)
  }, i = (a = (o = Z == null ? void 0 : Z.getIntegrations) == null ? void 0 : o.call(Z)) != null ? a : [];
  if (n.document_load !== void 0)
    for (const c of i)
      c.recordGauge((u = Z == null ? void 0 : Z.sessionSecureId) != null ? u : "", {
        name: Ds,
        value: n.document_load / 1e6
      });
  Object.entries(n).forEach(([c, s]) => {
    s !== void 0 && (e.setAttribute(`timings.${c}.ns`, s), e.setAttribute(
      `timings.${c}.readable`,
      hs(s)
    ));
  });
};
function $(e, t, r) {
  const n = r.find((u) => u.name === e), i = r.find((u) => u.name === t);
  if (!n || !i)
    return;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const Jg = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e9,
    connect: (t.connectEnd - t.connectStart) * 1e9,
    request: (t.responseEnd - t.requestStart) * 1e9,
    response: (t.responseEnd - t.responseStart) * 1e9
  };
  Object.entries(r).forEach(([n, i]) => {
    e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, hs(i));
  });
}, hs = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, ho = (e) => e === !0 ? [/localhost/, /^\//, new RegExp(window.location.host)] : Array.isArray(e) ? e.map(
  (t) => typeof t == "string" ? new RegExp(t) : t
) : /^$/, _s = (e) => e.attributes[ke] ? e.attributes[ke] : e.attributes[ne], Zg = 30, Qg = () => new Promise(
  (e) => requestAnimationFrame(
    (t) => requestAnimationFrame((r) => e(r - t))
  )
), ty = () => k(void 0, null, function* () {
  const e = [];
  for (let t = 0; t < Zg; t++)
    e.push(yield Qg());
  return e.reduce((t, r) => t + r, 0) / e.length;
}), ey = (e, t) => {
  let r = {}, n = 16.666666666666668;
  ty().then((c) => n = c);
  const i = (c) => {
    var s;
    r != null && r.event || (r = {
      event: c,
      location: window.location.href,
      timerStart: (s = window.performance) == null ? void 0 : s.now()
    }, window.requestAnimationFrame(o));
  }, o = () => {
    if (!(r != null && r.timerStart)) return;
    const c = window.performance.now() - r.timerStart - n;
    a(c), r = {};
  }, a = (c) => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: s,
      jankAmount: c,
      querySelector: u(),
      newLocation: window.location.href != r.location ? window.location.href : void 0
    });
  }, u = () => {
    var c;
    return (c = r == null ? void 0 : r.event) != null && c.target ? Bs(r.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, ry = typeof window != "undefined", _o = ry && "performance" in window && "memory" in performance ? performance : { memory: {} }, ny = (e, t) => {
  let r = 0, n = 0;
  const i = () => {
    const f = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, l = _o.memory.jsHeapSizeLimit || 0, d = _o.memory.usedJSHeapSize || 0;
    e({
      jsHeapSizeLimit: l,
      usedJSHeapSize: d,
      relativeTimestamp: f,
      fps: r
    });
  };
  i();
  let o;
  o = setInterval(() => {
    i();
  }, 1e3);
  let a = 0, u = Date.now();
  const c = function() {
    var s = Date.now();
    a++, s > 1e3 + u && (r = Math.round(a * 1e3 / (s - u)), a = 0, u = s), n = requestAnimationFrame(c);
  };
  return c(), () => {
    clearInterval(o), cancelAnimationFrame(n);
  };
};
var ut, ie, vs, Ke, Ln, Es = -1, Rt = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (Es = t.timeStamp, e(t));
  }, !0);
}, Fn = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, nr = function() {
  var e = Fn();
  return e && e.activationStart || 0;
}, j = function(e, t) {
  var r = Fn(), n = "navigate";
  return Es >= 0 ? n = "back-forward-cache" : r && (document.prerendering || nr() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, jt = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          t(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, r || {})), n;
    }
  } catch (i) {
  }
}, V = function(e, t, r, n) {
  var i, o;
  return function(a) {
    t.value >= 0 && (a || n) && ((o = t.value - (i || 0)) || i === void 0) && (i = t.value, t.delta = o, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, Xn = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, ir = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, zn = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, xt = -1, vo = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Je = function(e) {
  document.visibilityState === "hidden" && xt > -1 && (xt = e.type === "visibilitychange" ? e.timeStamp : 0, iy());
}, Eo = function() {
  addEventListener("visibilitychange", Je, !0), addEventListener("prerenderingchange", Je, !0);
}, iy = function() {
  removeEventListener("visibilitychange", Je, !0), removeEventListener("prerenderingchange", Je, !0);
}, Wn = function() {
  return xt < 0 && (xt = vo(), Eo(), Rt(function() {
    setTimeout(function() {
      xt = vo(), Eo();
    }, 0);
  })), { get firstHiddenTime() {
    return xt;
  } };
}, ye = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, go = [1800, 3e3], gs = function(e, t) {
  t = t || {}, ye(function() {
    var r, n = Wn(), i = j("FCP"), o = jt("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (o.disconnect(), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - nr(), 0), i.entries.push(u), r(!0)));
      });
    });
    o && (r = V(e, i, go, t.reportAllChanges), Rt(function(a) {
      i = j("FCP"), r = V(e, i, go, t.reportAllChanges), Xn(function() {
        i.value = performance.now() - a.timeStamp, r(!0);
      });
    }));
  });
}, yo = [0.1, 0.25], oy = function(e, t) {
  t = t || {}, gs(zn(function() {
    var r, n = j("CLS", 0), i = 0, o = [], a = function(c) {
      c.forEach(function(s) {
        if (!s.hadRecentInput) {
          var f = o[0], l = o[o.length - 1];
          i && s.startTime - l.startTime < 1e3 && s.startTime - f.startTime < 5e3 ? (i += s.value, o.push(s)) : (i = s.value, o = [s]);
        }
      }), i > n.value && (n.value = i, n.entries = o, r());
    }, u = jt("layout-shift", a);
    u && (r = V(e, n, yo, t.reportAllChanges), ir(function() {
      a(u.takeRecords()), r(!0);
    }), Rt(function() {
      i = 0, n = j("CLS", 0), r = V(e, n, yo, t.reportAllChanges), Xn(function() {
        return r();
      });
    }), setTimeout(r, 0));
  }));
}, Qt = { passive: !0, capture: !0 }, ay = /* @__PURE__ */ new Date(), mo = function(e, t) {
  ut || (ut = t, ie = e, vs = /* @__PURE__ */ new Date(), ms(removeEventListener), ys());
}, ys = function() {
  if (ie >= 0 && ie < vs - ay) {
    var e = { entryType: "first-input", name: ut.type, target: ut.target, cancelable: ut.cancelable, startTime: ut.timeStamp, processingStart: ut.timeStamp + ie };
    Ke.forEach(function(t) {
      t(e);
    }), Ke = [];
  }
}, sy = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, n) {
      var i = function() {
        mo(r, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, Qt), removeEventListener("pointercancel", o, Qt);
      };
      addEventListener("pointerup", i, Qt), addEventListener("pointercancel", o, Qt);
    }(t, e) : mo(t, e);
  }
}, ms = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, sy, Qt);
  });
}, To = [100, 300], uy = function(e, t) {
  t = t || {}, ye(function() {
    var r, n = Wn(), i = j("FID"), o = function(c) {
      c.startTime < n.firstHiddenTime && (i.value = c.processingStart - c.startTime, i.entries.push(c), r(!0));
    }, a = function(c) {
      c.forEach(o);
    }, u = jt("first-input", a);
    r = V(e, i, To, t.reportAllChanges), u && ir(zn(function() {
      a(u.takeRecords()), u.disconnect();
    })), u && Rt(function() {
      var c;
      i = j("FID"), r = V(e, i, To, t.reportAllChanges), Ke = [], ie = -1, ut = null, ms(addEventListener), c = o, Ke.push(c), ys();
    });
  });
}, Ts = 0, qr = 1 / 0, Ce = 0, cy = function(e) {
  e.forEach(function(t) {
    t.interactionId && (qr = Math.min(qr, t.interactionId), Ce = Math.max(Ce, t.interactionId), Ts = Ce ? (Ce - qr) / 7 + 1 : 0);
  });
}, Ss = function() {
  return Ln ? Ts : performance.interactionCount || 0;
}, fy = function() {
  "interactionCount" in performance || Ln || (Ln = jt("event", cy, { type: "event", buffered: !0, durationThreshold: 0 }));
}, So = [200, 500], Os = 0, Oo = function() {
  return Ss() - Os;
}, q = [], Yr = {}, Ao = function(e) {
  var t = q[q.length - 1], r = Yr[e.interactionId];
  if (r || q.length < 10 || e.duration > t.latency) {
    if (r) r.entries.push(e), r.latency = Math.max(r.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      Yr[n.id] = n, q.push(n);
    }
    q.sort(function(i, o) {
      return o.latency - i.latency;
    }), q.splice(10).forEach(function(i) {
      delete Yr[i.id];
    });
  }
}, ly = function(e, t) {
  t = t || {}, ye(function() {
    var r;
    fy();
    var n, i = j("INP"), o = function(u) {
      u.forEach(function(f) {
        f.interactionId && Ao(f), f.entryType === "first-input" && !q.some(function(l) {
          return l.entries.some(function(d) {
            return f.duration === d.duration && f.startTime === d.startTime;
          });
        }) && Ao(f);
      });
      var c, s = (c = Math.min(q.length - 1, Math.floor(Oo() / 50)), q[c]);
      s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
    }, a = jt("event", o, { durationThreshold: (r = t.durationThreshold) !== null && r !== void 0 ? r : 40 });
    n = V(e, i, So, t.reportAllChanges), a && ("interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), ir(function() {
      o(a.takeRecords()), i.value < 0 && Oo() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), Rt(function() {
      q = [], Os = Ss(), i = j("INP"), n = V(e, i, So, t.reportAllChanges);
    }));
  });
}, bo = [2500, 4e3], Kr = {}, dy = function(e, t) {
  t = t || {}, ye(function() {
    var r, n = Wn(), i = j("LCP"), o = function(c) {
      var s = c[c.length - 1];
      s && s.startTime < n.firstHiddenTime && (i.value = Math.max(s.startTime - nr(), 0), i.entries = [s], r());
    }, a = jt("largest-contentful-paint", o);
    if (a) {
      r = V(e, i, bo, t.reportAllChanges);
      var u = zn(function() {
        Kr[i.id] || (o(a.takeRecords()), a.disconnect(), Kr[i.id] = !0, r(!0));
      });
      ["keydown", "click"].forEach(function(c) {
        addEventListener(c, function() {
          return setTimeout(u, 0);
        }, !0);
      }), ir(u), Rt(function(c) {
        i = j("LCP"), r = V(e, i, bo, t.reportAllChanges), Xn(function() {
          i.value = performance.now() - c.timeStamp, Kr[i.id] = !0, r(!0);
        });
      });
    }
  });
}, wo = [800, 1800], py = function e(t) {
  document.prerendering ? ye(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, hy = function(e, t) {
  t = t || {};
  var r = j("TTFB"), n = V(e, r, wo, t.reportAllChanges);
  py(function() {
    var i = Fn();
    if (i) {
      var o = i.responseStart;
      if (o <= 0 || o > performance.now()) return;
      r.value = Math.max(o - nr(), 0), r.entries = [i], n(!0), Rt(function() {
        r = j("TTFB", 0), (n = V(e, r, wo, t.reportAllChanges))(!0);
      });
    }
  });
};
const _y = (e) => (oy(e), gs(e), uy(e), dy(e), hy(e), ly(e), () => {
}), Mt = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, vy = (e, t) => {
  const r = () => {
    const o = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: o,
      downlink: Mt.downlink,
      downlinkMax: Mt.downlinkMax,
      effectiveType: Mt.effectiveType,
      rtt: Mt.rtt,
      saveData: Mt.saveData,
      type: Mt.type
    });
  };
  r();
  let n;
  return n = setInterval(() => {
    r();
  }, 1e3), () => {
    clearInterval(n);
  };
}, Ey = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const e = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: gy(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const n = Jr(
        e.memory.jsHeapSizeLimit
      ), i = Jr(
        e.memory.totalJSHeapSize
      ), o = Jr(
        e.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: i,
        usedJSHeapSize: o
      };
    }
  };
}, Jr = (e) => e / Math.pow(1e3, 2), gy = (e) => 1024 * e;
function yy(e) {
  return "regexValue" in e;
}
function my(e) {
  return "matchValue" in e;
}
function Ty(e) {
  const t = Math.trunc(e);
  return t === 1 ? !0 : t === 0 ? !1 : Math.floor(Math.random() * t) === 0;
}
class Sy {
  /**
   * @param config The sampling configuration.
   * @param sampler The sampler to use. This is intended to be used for testing purposes.
   */
  constructor(t = Ty) {
    R(this, "regexCache", /* @__PURE__ */ new Map());
    R(this, "config");
    this.sampler = t;
  }
  setConfig(t) {
    this.config = t;
  }
  isSamplingEnabled() {
    var t, r, n, i;
    return !!((r = (t = this.config) == null ? void 0 : t.logs) != null && r.length || (i = (n = this.config) == null ? void 0 : n.spans) != null && i.length);
  }
  shouldSample(t) {
    var r, n;
    return t.name === cs ? this.sampleLog((r = this.config) == null ? void 0 : r.logs, t) : this.sampleSpan((n = this.config) == null ? void 0 : n.spans, t);
  }
  /**
   * Check if a value matches a match config.
   */
  matchesValue(t, r) {
    if (!t)
      return !1;
    if (my(t))
      return t.matchValue === r;
    if (yy(t)) {
      const n = t.regexValue;
      if (n === null)
        return !1;
      this.regexCache.has(n) || this.regexCache.set(n, new RegExp(n));
      const i = this.regexCache.get(n);
      if (typeof r == "string")
        return i.test(r);
    }
    return !1;
  }
  /**
   * Check if the attributes match the attribute configs.
   */
  matchesAttributes(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of Object.keys(r))
          if (this.matchesValue(n.key, o)) {
            const a = r[o];
            if (this.matchesValue(
              n.attribute,
              a
            )) {
              i = !0;
              break;
            }
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  matchEvent(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || t.attributes && (!r.attributes || !this.matchesAttributes(
      t.attributes,
      r.attributes
    )));
  }
  matchesEvents(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of r)
          if (this.matchEvent(n, o)) {
            i = !0;
            break;
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  /**
   * Attempts to match the span to the config. The span will match only if all defined conditions are met.
   *
   * @param config The config to match against.
   * @param name The name of the span to match.
   * @param attributes The attributes of the span to match.
   * @returns True if the span matches the config, false otherwise.
   */
  matchesSpanConfig(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || !this.matchesAttributes(t.attributes, r.attributes) || !this.matchesEvents(t.events, r.events));
  }
  matchesLogConfig(t, r) {
    if (t.severityText) {
      const n = r[fs];
      if (!this.matchesValue(t.severityText, n))
        return !1;
    }
    if (t.message) {
      const n = r[ls];
      if (!this.matchesValue(t.message, n))
        return !1;
    }
    return !!this.matchesAttributes(t.attributes, r);
  }
  /**
   * Sample a span based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param name The name of the span to sample.
   * @param attributes The attributes of the span to sample.
   * @returns The sampling result.
   */
  sampleSpan(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesSpanConfig(n, r))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [uo]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
  /**
   * Sample a log based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param attributes The attributes of the log to sample.
   * @returns The sampling result.
   */
  sampleLog(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesLogConfig(n, r.attributes))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [uo]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
}
const Ro = () => {
  const e = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (t, r) => e,
    setAttributes: (t) => e,
    addEvent: (t, r, n) => e,
    addLinks: (t) => e,
    setStatus: (t) => e,
    recordException: () => {
    },
    addLink: () => e,
    updateName: () => e,
    isRecording: () => !1
  };
  return e;
}, Oy = "exception", Ay = function(e, t, r) {
  if (!e)
    return;
  const n = S({}, r);
  typeof t == "string" ? n[cr] = t : t && (t.code ? n[ur] = t.code.toString() : t.name && (n[ur] = t.name), t.message && (n[cr] = t.message), t.stack && (n[ks] = t.stack)), n[ur] || n[cr] ? e.addEvent(Oy, n) : su(
    "otel",
    "recordException",
    "warn",
    `Failed to record an exception ${t}`
  );
};
class by {
  constructor(t) {
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    R(this, "organizationID");
    R(this, "_options");
    R(this, "_integrations", []);
    R(this, "_gauges", /* @__PURE__ */ new Map());
    R(this, "_counters", /* @__PURE__ */ new Map());
    R(this, "_histograms", /* @__PURE__ */ new Map());
    R(this, "_up_down_counters", /* @__PURE__ */ new Map());
    R(this, "sampler", new Sy());
    R(this, "_started", !1);
    R(this, "graphqlSDK");
    this._options = t, this.organizationID = t.projectId;
  }
  start() {
    return k(this, null, function* () {
      var r, n, i, o, a, u, c, s, f, l, d, h, _, p, E, g, y;
      if (this._started)
        return;
      this._started = !0, $g(
        {
          backendUrl: (n = (r = this._options) == null ? void 0 : r.backendUrl) != null ? n : "https://pub.observability.app.launchdarkly.com",
          otlpEndpoint: (a = (o = (i = this._options) == null ? void 0 : i.otel) == null ? void 0 : o.otlpEndpoint) != null ? a : "https://otel.observability.app.launchdarkly.com",
          projectId: this._options.projectId,
          sessionSecureId: this._options.sessionSecureId,
          environment: (c = (u = this._options) == null ? void 0 : u.environment) != null ? c : "production",
          networkRecordingOptions: typeof ((s = this._options) == null ? void 0 : s.networkRecording) == "object" ? this._options.networkRecording : void 0,
          tracingOrigins: (f = this._options) == null ? void 0 : f.tracingOrigins,
          serviceName: (d = (l = this._options) == null ? void 0 : l.serviceName) != null ? d : "browser",
          serviceVersion: (h = this._options) == null ? void 0 : h.version,
          instrumentations: (p = (_ = this._options) == null ? void 0 : _.otel) == null ? void 0 : p.instrumentations,
          eventNames: (g = (E = this._options) == null ? void 0 : E.otel) == null ? void 0 : g.eventNames,
          getIntegrations: () => this._integrations
        },
        this.sampler
      ), this._gauges.clear(), this._counters.clear(), this._histograms.clear(), this._up_down_counters.clear();
      const t = new $s(
        (y = this._options.backendUrl) != null ? y : "https://pub.observability.app.launchdarkly.com",
        {
          headers: {}
        }
      );
      this.graphqlSDK = Gs(t, Hs()), yield this.configureSampling(), this.setupListeners();
    });
  }
  stop() {
    return k(this, null, function* () {
      this._started && (this._started = !1, yield zg());
    });
  }
  configureSampling() {
    return k(this, null, function* () {
      try {
        const t = yield this.graphqlSDK.GetSamplingConfig({
          organization_verbose_id: `${this.organizationID}`
        });
        this.sampler.setConfig(t.sampling);
      } catch (t) {
        Mo(
          "sampling",
          "warn",
          `LaunchDarkly Observability: Failed to configure sampling: ${t}`
        );
      }
    });
  }
  _recordLog(t, r, n, i) {
    this.startSpan(cs, (o) => {
      const a = typeof t == "string" ? t : Dt(t), u = i ? Dt(i.map((c) => c.toString())) : void 0;
      if (o == null || o.addEvent("log", S({
        [fs]: r,
        [ls]: a,
        "code.stacktrace": u
      }, n)), this._options.reportConsoleErrors && r === "error") {
        o == null || o.recordException(new Error(a)), o == null || o.setStatus({
          code: He.ERROR,
          message: a
        });
        const c = new Error(a);
        i && (c.stack = u), this.recordError(c);
      }
    });
  }
  _recordErrorMessage(t, r) {
    try {
      t.payload && (r = S(S({}, JSON.parse(t.payload)), r || {}));
    } catch (a) {
    }
    this.startSpan("highlight.exception", (a) => {
      var u;
      Ay(a, (u = t.error) != null ? u : new Error(t.event), {
        [Hg]: t.id
      }), a == null || a.setAttributes(S({
        event: t.event,
        type: t.type,
        url: t.url,
        source: t.source,
        lineNumber: t.lineNumber,
        columnNumber: t.columnNumber
      }, r));
    });
    const o = t, { payload: n } = o, i = sr(o, ["payload"]);
    for (const a of this._integrations)
      a.error(at(), P(S({}, i), {
        payload: JSON.stringify(r)
      }));
  }
  recordError(t, r, n, i, o) {
    var s, f, l, d;
    t = t || new Error("Unknown error"), t instanceof Error && t.cause && (n = P(S({}, n), {
      "exception.cause": JSON.stringify(t.cause)
    }));
    let a = r ? r + ":" + t.message : t.message;
    o === "React.ErrorBoundary" && (a = "ErrorBoundary: " + a);
    const u = Ze(t), c = {
      error: t,
      event: a,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: i != null ? i : "frontend",
      lineNumber: (s = u[0]) != null && s.lineNumber ? (f = u[0]) == null ? void 0 : f.lineNumber : 0,
      columnNumber: (l = u[0]) != null && l.columnNumber ? (d = u[0]) == null ? void 0 : d.columnNumber : 0,
      stackTrace: u,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      id: Uo()
    };
    this._recordErrorMessage(c, n);
  }
  recordCount(t) {
    var n;
    let r = this._counters.get(t.name);
    if (!r) {
      if (r = (n = Ie()) == null ? void 0 : n.createCounter(t.name), !r) return;
      this._counters.set(t.name, r);
    }
    r.add(t.value, P(S({}, t.attributes), {
      "highlight.session_id": at()
    }));
  }
  recordGauge(t) {
    var i, o, a, u;
    let r = this._gauges.get(t.name);
    if (!r) {
      if (r = (i = Ie()) == null ? void 0 : i.createGauge(t.name), !r) return;
      this._gauges.set(t.name, r);
    }
    r.record(t.value, P(S({}, t.attributes), {
      "highlight.session_id": at()
    }));
    const n = {
      name: t.name,
      value: t.value,
      category: (o = t.attributes) == null ? void 0 : o.category,
      group: (u = (a = t.attributes) == null ? void 0 : a.group) == null ? void 0 : u.toString(),
      tags: t.attributes ? Object.entries(t.attributes).map(([c, s]) => {
        var f;
        return {
          name: c != null ? c : "",
          value: (f = s == null ? void 0 : s.toString()) != null ? f : ""
        };
      }) : []
    };
    for (const c of this._integrations)
      c.recordGauge(
        at(),
        n
      );
  }
  recordIncr(t) {
    this.recordCount(P(S({}, t), { value: 1 }));
  }
  recordHistogram(t) {
    var n;
    let r = this._histograms.get(t.name);
    if (!r) {
      if (r = (n = Ie()) == null ? void 0 : n.createHistogram(t.name), !r) return;
      this._histograms.set(t.name, r);
    }
    r.record(t.value, P(S({}, t.attributes), {
      "highlight.session_id": at()
    }));
  }
  recordUpDownCounter(t) {
    var n;
    let r = this._up_down_counters.get(t.name);
    if (!r) {
      if (r = (n = Ie()) == null ? void 0 : n.createUpDownCounter(t.name), !r) return;
      this._up_down_counters.set(t.name, r);
    }
    r.add(t.value, P(S({}, t.attributes), {
      "highlight.session_id": at()
    }));
  }
  startSpan(t, r, n, i) {
    const o = co();
    if (!o) {
      const u = Ro();
      return i === void 0 && n === void 0 ? r(u) : i === void 0 ? n(u) : i(u);
    }
    const a = (u, c) => {
      const s = c(u);
      return s instanceof Promise ? s.finally(() => u.end()) : (u.end(), s);
    };
    return i === void 0 && n === void 0 ? o.startActiveSpan(
      t,
      (u) => a(u, r)
    ) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      (u) => a(u, n)
    ) : o.startActiveSpan(
      t,
      r,
      n,
      (u) => a(u, i)
    );
  }
  startManualSpan(t, r, n, i) {
    const o = co();
    if (!o) {
      const a = Ro();
      return i === void 0 && n === void 0 ? r(a) : i === void 0 ? n(a) : i(a);
    }
    return i === void 0 && n === void 0 ? o.startActiveSpan(t, r) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      n
    ) : o.startActiveSpan(
      t,
      r,
      n,
      i
    );
  }
  register(t, r) {
    this._integrations.push(new js(t, r));
  }
  getHooks(t) {
    return this._integrations.flatMap((r) => {
      var n, i;
      return (i = (n = r.getHooks) == null ? void 0 : n.call(r, t)) != null ? i : [];
    });
  }
  submitViewportMetrics({
    height: t,
    width: r,
    availHeight: n,
    availWidth: i
  }) {
    this.recordGauge({
      name: pt.ViewportHeight,
      value: t,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: pt.ViewportWidth,
      value: r,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: pt.ScreenHeight,
      value: n,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: pt.ScreenWidth,
      value: i,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: pt.ViewportArea,
      value: t * r,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    });
  }
  setupListeners() {
    var r;
    this._options.disableConsoleRecording || lu(
      (n) => {
        var i;
        this._recordLog(
          (i = n.value) == null ? void 0 : i.join(" "),
          n.type,
          n.attributes ? JSON.parse(n.attributes) : {},
          n.trace
        );
      },
      {
        level: (r = this._options.consoleMethodsToRecord) != null ? r : [
          ...xo
        ],
        logger: "console",
        stringifyOptions: {
          depthOfLimit: 10,
          numOfKeysLimit: 100,
          stringLengthLimit: 1e3
        }
      }
    ), this._options.enablePerformanceRecording !== !1 && (ny((n) => {
      Object.entries(n).filter(([i]) => i !== "relativeTimestamp").forEach(
        ([i, o]) => o && this.recordGauge({
          name: i,
          value: o,
          attributes: {
            category: F.Performance,
            group: window.location.href
          }
        })
      );
    }, 0), ey((n) => {
      this.recordGauge({
        name: "Jank",
        value: n.jankAmount,
        attributes: {
          category: F.WebVital,
          group: n.querySelector
        }
      });
    }, 0)), mu(
      (n) => {
        var a;
        if (Su.includes(n.event) || Ou.some(
          (u) => n.event.includes(u)
        ))
          return;
        const i = new Error(n.event);
        i.stack = Dt(n.stackTrace.map((u) => u.toString()));
        let o = {};
        try {
          n.payload && (o = JSON.parse(n.payload));
        } catch (u) {
        }
        this._recordErrorMessage(
          P(S({}, n), { error: (a = n.error) != null ? a : i }),
          o
        );
      },
      { enablePromisePatch: !!this._options.enablePromisePatch }
    ), _y((n) => {
      const { name: i, value: o } = n, { hostname: a, pathname: u, href: c } = window.location;
      this.recordGauge({
        name: i,
        value: o,
        attributes: {
          group: window.location.pathname,
          category: F.WebVital,
          [ke]: Pa(c),
          [Co]: u,
          [Xs]: a
        }
      });
    }), Vs((n) => {
      this.submitViewportMetrics(n);
    }), vy((n) => {
      const i = {
        category: F.Performance,
        group: window.location.href
      };
      n.saveData !== void 0 && (i.saveData = n.saveData.toString()), n.effectiveType !== void 0 && (i.effectiveType = n.effectiveType.toString()), n.type !== void 0 && (i.type = n.type.toString()), Object.entries(n).filter(([o]) => o !== "relativeTimestamp").forEach(([o, a]) => {
        Fs(a) && this.recordGauge({
          name: o,
          value: a,
          attributes: i
        });
      });
    }, (/* @__PURE__ */ new Date()).getTime());
    const { getDeviceDetails: t } = Ey();
    t && this.recordGauge({
      name: pt.DeviceMemory,
      value: t().deviceMemory,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    });
  }
  recordLog(t, r, n) {
    return this._recordLog(t, r, n);
  }
}
class Dy extends zs {
  constructor(r) {
    super(r);
    R(this, "observe");
    R(this, "options");
    this.options = r;
  }
  initialize(r, n) {
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        console.warn(
          "@launchdarkly/observability is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (!r) {
        console.warn(
          "@launchdarkly/observability is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(r, n), this.observe = new by(P(S({}, n), {
        projectId: r,
        sessionSecureId: this.sessionSecureID
      })), n != null && n.manualStart || this.observe.start(), uu.load(this.observe);
    } catch (i) {
      Mo(
        "Error initializing @launchdarkly/observability SDK",
        "error",
        i
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/observability"
    };
  }
  register(r, n) {
    var i;
    (i = this.observe) == null || i.register(r, n);
  }
  getHooks(r) {
    var i, o, a, u;
    const n = S(S({
      [eu]: r.sdk.name,
      [tu]: r.sdk.version,
      [Qs]: r.clientSideId,
      [Zs]: "LaunchDarkly"
    }, (i = r.application) != null && i.id ? { [Js]: r.application.id } : {}), (o = r.application) != null && o.version ? {
      [Ks]: r.application.version
    } : {});
    return this.initialize(
      (u = (a = r.sdkKey) != null ? a : r.mobileKey) != null ? u : r.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/observability/hooks"
        }),
        afterIdentify: (c, s, f) => {
          var l, d, h, _, p, E, g, y;
          for (const b of (h = (d = (l = this.observe) == null ? void 0 : l.getHooks) == null ? void 0 : d.call(l, r)) != null ? h : [])
            (_ = b.afterIdentify) == null || _.call(b, c, s, f);
          if (f.status === "completed") {
            const b = P(S({}, Kn(c.context)), {
              key: (g = (E = (p = this.options) == null ? void 0 : p.contextFriendlyName) == null ? void 0 : E.call(
                p,
                c.context
              )) != null ? g : fr(c.context),
              timeout: c.timeout,
              canonicalKey: fr(c.context),
              [au]: f.status
            });
            (y = this.observe) == null || y.recordLog("LD.identify", "info", S(S({}, n), b));
          }
          return s;
        },
        afterEvaluation: (c, s, f) => {
          var h, _, p, E, g;
          for (const y of (p = (_ = (h = this.observe) == null ? void 0 : h.getHooks) == null ? void 0 : _.call(h, r)) != null ? p : [])
            (E = y.afterEvaluation) == null || E.call(y, c, s, f);
          const l = S({
            [nu]: c.flagKey,
            [Ws]: JSON.stringify(f.value)
          }, f.variationIndex ? {
            [ru]: f.variationIndex
          } : {});
          if (f.reason)
            for (const y in Jn) {
              const b = y, L = f.reason[b];
              L && (l[Jn[b]] = L);
            }
          c.context && (l[iu] = JSON.stringify(Kn(c.context)), l[ou] = fr(c.context));
          const d = S(S({}, n), l);
          return (g = this.observe) == null || g.startSpan(qs, (y) => {
            y && y.addEvent(Ys, d);
          }), s;
        },
        afterTrack: (c) => {
          var s, f, l, d, h;
          for (const _ of (l = (f = (s = this.observe) == null ? void 0 : s.getHooks) == null ? void 0 : f.call(s, r)) != null ? l : [])
            (d = _.afterTrack) == null || d.call(_, c);
          (h = this.observe) == null || h.recordLog("LD.track", "info", S(P(S({}, n), {
            key: c.key,
            value: c.metricValue
          }), typeof c.data == "object" ? c.data : {}));
        }
      }
    ];
  }
}
export {
  xo as A,
  lu as C,
  i_ as D,
  mu as E,
  xy as F,
  ey as J,
  F as M,
  vy as N,
  Dy as O,
  ny as P,
  _y as W,
  My as X,
  kn as a,
  Su as b,
  Ou as c,
  Ny as d,
  du as e,
  $g as f,
  Sy as g,
  Ey as h,
  pt as i,
  Ie as j,
  Ia as k,
  co as l,
  Cy as m,
  Ro as n,
  Ze as p,
  Uo as r,
  zg as s
};
//# sourceMappingURL=observe-ZyqxkVF-.js.map
